import classes from "./HeroImg.module.css"
import { motion } from "framer-motion"

const codeVariants = {
  end: {
    y: [0, 10, 5, 10, 0],
    transition: {
      repeatType: "mirror",
      repeat: Infinity,
      duration: 3
    },
  },
}
const code2Variants = {
  end: {
    x: [0, 10, 5, 10, 0],
    transition: {
      repeatType: "mirror",
      repeat: Infinity,
      duration: 7
    },
  },
}

const planet1Variants = {
  end: {
    rotateZ: [0, 10, 5, 10, 0],
    transition: {
      delay: 1,
      repeatType: "mirror",
      repeat: Infinity,
      duration: 3,
    },
  },
}
const planet2Variants = {
  end: {
    rotateZ: [0, 10, 5, 10, 0],
    transition: {
      repeatType: "mirror",
      repeat: Infinity,
      duration: 4,
    },
  },
}
export const HeroImg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448.45 461.64">
      <defs></defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Text_Boxes">
          <ellipse
            id="Floor"
            className={classes.cls_1}
            cx="224.23"
            cy="337.49"
            rx="224.23"
            ry="124.15"
          />
          <path
            id="Shadow"
            className={classes.cls_2}
            d="M426.05,318.27l-125,72.21a3.75,3.75,0,0,1-3.36,0l-180.22-104a1,1,0,0,1,0-1.94l125-72.21a3.73,3.73,0,0,1,3.35,0l180.22,104A1,1,0,0,1,426.05,318.27Z"
          />
          <ellipse
            id="Shadow-2"
            data-name="Shadow"
            className={classes.cls_2}
            cx="135.6"
            cy="387.52"
            rx="75.08"
            ry="43.35"
          />
          <ellipse
            id="Shadow-3"
            data-name="Shadow"
            className={classes.cls_2}
            cx="227.02"
            cy="337.26"
            rx="59.1"
            ry="34.12"
          />
          <ellipse
            id="Shadow-4"
            data-name="Shadow"
            className={classes.cls_2}
            cx="358.45"
            cy="382.99"
            rx="37.1"
            ry="21.42"
          />
          <g id="Desk">
            <g id="Table">
              <path
                className={classes.cls_3}
                d="M303.79,261.49V372.43a2.45,2.45,0,0,1-1.12,1.94l-2.38,1.38a2.52,2.52,0,0,1-2.24,0l-2.38-1.38a2.45,2.45,0,0,1-1.12-1.94V261.49c0-.71.5-1,1.12-.65l2.38,1.38a2.52,2.52,0,0,0,2.24,0l2.38-1.38C303.29,260.49,303.79,260.78,303.79,261.49Z"
              />
              <path
                className={classes.cls_4}
                d="M298.05,375.75l-2.38-1.38a2.45,2.45,0,0,1-1.12-1.94V261.49c0-.71.5-1,1.12-.65l2.38,1.38a2.45,2.45,0,0,1,1.12,1.94V375.1C299.17,375.81,298.67,376.1,298.05,375.75Z"
              />
              <path
                className={classes.cls_3}
                d="M405.3,202.85V313.79a2.48,2.48,0,0,1-1.12,1.94l-2.38,1.37a2.46,2.46,0,0,1-2.24,0l-2.38-1.37a2.48,2.48,0,0,1-1.12-1.94V202.85c0-.72.5-1,1.12-.65l2.38,1.37a2.46,2.46,0,0,0,2.24,0l2.38-1.37C404.8,201.84,405.3,202.13,405.3,202.85Z"
              />
              <path
                className={classes.cls_4}
                d="M399.56,317.1l-2.38-1.37a2.48,2.48,0,0,1-1.12-1.94V202.85c0-.72.5-1,1.12-.65l2.38,1.37a2.48,2.48,0,0,1,1.12,1.94v111C400.68,317.17,400.18,317.46,399.56,317.1Z"
              />
              <path
                className={classes.cls_3}
                d="M167.07,182.6V293.54a2.48,2.48,0,0,1-1.11,1.94l-2.39,1.37a2.46,2.46,0,0,1-2.24,0L159,295.48a2.48,2.48,0,0,1-1.11-1.94V182.6c0-.72.5-1,1.11-.65l2.39,1.38a2.5,2.5,0,0,0,2.23,0L166,182C166.57,181.59,167.07,181.88,167.07,182.6Z"
              />
              <path
                className={classes.cls_4}
                d="M161.33,296.85,159,295.48a2.48,2.48,0,0,1-1.11-1.94V182.6c0-.72.5-1,1.11-.65l2.39,1.38a2.47,2.47,0,0,1,1.11,1.93v111C162.45,296.92,162,297.21,161.33,296.85Z"
              />
              <path
                className={classes.cls_5}
                d="M427.39,210.74v-.81a4.49,4.49,0,0,0-2-3.53l-179-103.26a4.49,4.49,0,0,0-4.07,0L132.13,166.75a4.52,4.52,0,0,0-2,3.53v.81a4.52,4.52,0,0,0,2,3.53l179,103.25a4.49,4.49,0,0,0,4.07,0l110.13-63.6A4.52,4.52,0,0,0,427.39,210.74Z"
              />
              <path
                className={classes.cls_6}
                d="M427.39,210.74v-.81a4.49,4.49,0,0,0-2-3.53l-179-103.26a4.49,4.49,0,0,0-4.07,0L132.13,166.75a4.52,4.52,0,0,0-2,3.53v.81a4.52,4.52,0,0,0,2,3.53l179,103.25a4.49,4.49,0,0,0,4.07,0l110.13-63.6A4.52,4.52,0,0,0,427.39,210.74Z"
              />
              <path
                className={classes.cls_5}
                d="M313.19,272.84v5.52a4.32,4.32,0,0,0,2-.48l110.13-63.61a4.51,4.51,0,0,0,2-3.53v-.81a4.51,4.51,0,0,0-1.67-3.27c.74.63.62,1.51-.37,2.09L315.22,272.36A4.09,4.09,0,0,1,313.19,272.84Z"
              />
              <path
                className={classes.cls_7}
                d="M313.19,272.84v5.52a4.32,4.32,0,0,0,2-.48l110.13-63.61a4.51,4.51,0,0,0,2-3.53v-.81a4.51,4.51,0,0,0-1.67-3.27c.74.63.62,1.51-.37,2.09L315.22,272.36A4.09,4.09,0,0,1,313.19,272.84Z"
              />
              <path
                className={classes.cls_5}
                d="M425.35,208.75l-110.13,63.6a4.49,4.49,0,0,1-4.07,0l-179-103.25a1.24,1.24,0,0,1,0-2.35l110.13-63.61a4.49,4.49,0,0,1,4.07,0l179,103.26A1.24,1.24,0,0,1,425.35,208.75Z"
              />
              <path
                className={classes.cls_8}
                d="M425.35,208.75l-110.13,63.6a4.49,4.49,0,0,1-4.07,0l-179-103.25a1.24,1.24,0,0,1,0-2.35l110.13-63.61a4.49,4.49,0,0,1,4.07,0l179,103.26A1.24,1.24,0,0,1,425.35,208.75Z"
              />
            </g>
            <g id="Keyboard">
              <path
                id="Shadow-5"
                data-name="Shadow"
                className={classes.cls_9}
                d="M299.66,207.36l-26.1,15.11a3.2,3.2,0,0,1-2.92,0L193.56,178a.89.89,0,0,1,0-1.69l26.1-15.11a3.2,3.2,0,0,1,2.92,0l77.09,44.44A.9.9,0,0,1,299.66,207.36Z"
              />
              <g id="Keyboard-2" data-name="Keyboard">
                <path
                  className={classes.cls_10}
                  d="M195.14,173.66a1,1,0,0,1,.6-.85l24.52-14.15a3.23,3.23,0,0,1,2.92,0L298,201.92a1,1,0,0,1,.6.84v2.57a1,1,0,0,1-.61.85l-24.5,14.15a3.23,3.23,0,0,1-2.92,0l-74.81-43.18a1,1,0,0,1-.6-.84Z"
                />
                <path
                  className={classes.cls_3}
                  d="M273.47,217.69,298,203.61a.89.89,0,0,0,0-1.69l-74.8-43.25a3.23,3.23,0,0,0-2.92,0l-24.52,14.15a.89.89,0,0,0,0,1.69l74.81,43.19A3.23,3.23,0,0,0,273.47,217.69Z"
                />
                <path
                  className={classes.cls_10}
                  d="M272.1,218v2.63a3.09,3.09,0,0,0,1.38-.34L298,206.18a1.05,1.05,0,0,0,.61-.84v-2.58a1,1,0,0,1-.61.84l-24.49,14.1A3.09,3.09,0,0,1,272.1,218Z"
                />
                <path
                  className={classes.cls_11}
                  d="M199.68,173.85a0,0,0,0,1,0,0l2.43-1.4,3.29,1.9L203,175.76l-3.29-1.89Zm3.79-2.2s0,0,0,0l2.43-1.4,2.58,1.5-2.44,1.44-2.58-1.49Zm.8,4.85s0,0,0,0l2.43-1.4,2.58,1.49L206.86,178l-2.58-1.49Zm3-7s0,0,0,0l2.42-1.4,4.18,2.41-2.44,1.45-4.17-2.41Zm.1,4.44a.1.1,0,0,1,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2-1.18Zm.79,4.85a0,0,0,0,1,0,0l2.43-1.4,2.58,1.49-2.44,1.45-2.58-1.49Zm2.56-2.91,0,0,2.43-1.4,2.05,1.19L212.78,177l-2.05-1.18Zm.35-8.57s0,0,0,0l2.42-1.4,3.29,1.9-2.44,1.45-3.29-1.9Zm1,13.73s0,0,0,0l2.43-1.4,18.68,10.79-2.45,1.44L212.06,181Zm.69-8.37a0,0,0,0,1,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm1.34,5.15a0,0,0,0,1,0,0l2.43-1.4,2.05,1.19L216.14,179l-2-1.18Zm.78-12.7a.05.05,0,0,1,0,0l2.42-1.4,2.05,1.19-2.44,1.45-2-1.18Zm.8,4.84s0,0,0,0l2.43-1.4,2,1.19-2.44,1.45-2.05-1.19Zm.44,4.65a0,0,0,0,1,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2-1.18Zm1.34,5.15a0,0,0,0,1,0,0l2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm.78-12.7a.05.05,0,0,1,0,0l2.42-1.39,2.05,1.18-2.44,1.45L218.23,167Zm.8,4.84s0,0,0,0l2.42-1.4,2.05,1.19-2.44,1.45L219,171.88Zm.44,4.65a0,0,0,0,1,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm0-14.09s0,0,0,0l2.43-1.4,2.58,1.5-2.44,1.44-2.58-1.49Zm1.33,19.24a0,0,0,0,1,0,0l2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm.78-12.7a.05.05,0,0,1,0,0l2.42-1.39,2.05,1.18-2.44,1.45-2-1.18Zm.8,4.85a.05.05,0,0,1,0,0l2.42-1.4,2,1.19L224.44,175l-2.05-1.19Zm.45,4.64a0,0,0,0,1,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2-1.18Zm1.33,5.15a0,0,0,0,1,0,0l2.43-1.4,2,1.19-2.44,1.44-2.05-1.18Zm.66-18.09s0,0,0,0l2.42-1.41,2.06,1.19-2.45,1.45-2-1.19Zm.12,5.39a.05.05,0,0,1,0,0l2.42-1.4,2.05,1.19L227,172.1,225,170.91Zm.8,4.84s0,0,0,0l2.42-1.4,2.06,1.19L227.8,177l-2.05-1.19Zm.44,4.65a0,0,0,0,1,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm1.33,5.15,0,0,2.43-1.4L232,185.3l-2.44,1.44-2.05-1.18Zm.67-18.09a.05.05,0,0,1,0,0l2.42-1.4,2.06,1.19-2.45,1.45-2.05-1.19Zm.12,5.39a0,0,0,0,1,0,0l2.43-1.4,2.05,1.18L230.36,174l-2.05-1.18Zm.8,4.85a.05.05,0,0,1,0,0l2.42-1.4,2.06,1.19-2.45,1.45-2-1.19Zm.44,4.64a0,0,0,0,1,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm1.34,5.15v0l2.43-1.4,2,1.19-2.44,1.44-2.05-1.18Zm.66-18.09a.05.05,0,0,1,0,0L234,168l2.06,1.19-2.45,1.45-2-1.19Zm.12,5.39a.05.05,0,0,1,0,0l2.42-1.39,2,1.18L233.72,176l-2.05-1.18Zm.37,17.75s0,0,0,0l2.42-1.4,2.59,1.49L234.62,194,232,192.55Zm.43-12.91,0,0,2.42-1.4,2.06,1.19-2.45,1.45-2.05-1.19Zm.44,4.65a0,0,0,0,1,0,0l2.43-1.4,2,1.18L235,185.47l-2.05-1.18Zm1.34,5.15a0,0,0,0,1,0,0l2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm.66-18.09s0,0,0,0l2.42-1.41,2.06,1.19L237,172.53l-2.05-1.19Zm.12,5.39a.05.05,0,0,1,0,0l2.42-1.4,2.05,1.19-2.44,1.45L235,176.73Zm.8,4.84,0,0,2.42-1.4,2.06,1.19-2.45,1.45-2-1.19Zm.1,13.22s0,0,0,0l2.42-1.4,2.59,1.49-2.44,1.45-2.58-1.49Zm.34-8.57a0,0,0,0,1,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm1.34,5.15a.1.1,0,0,1,0,0l2.43-1.4,2,1.19-2.44,1.44-2-1.18Zm.78-12.7a0,0,0,0,1,0,0l2.43-1.4,2,1.18-2.44,1.45-2.05-1.18Zm.8,4.84,0,0,2.42-1.4,2.05,1.19-2.44,1.45-2.05-1.19Zm.44,4.65a0,0,0,0,1,0,0l2.43-1.4,2,1.18-2.44,1.45-2.05-1.18Zm.1-14s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45-2-1.18Zm.09,22.92a.05.05,0,0,1,0,0l2.42-1.4,2.59,1.5-2.44,1.44L239.82,197ZM241,193.3a0,0,0,0,1,0,0l2.43-1.4,2.05,1.19L243,194.5,241,193.32Zm.78-12.7a.05.05,0,0,1,0,0l2.42-1.39,2.05,1.18-2.44,1.45-2.05-1.19Zm.8,4.84,0,0L245,184l2.06,1.19-2.45,1.45-2-1.19Zm.44,4.65a0,0,0,0,1,0,0l2.43-1.4,2.05,1.18-2.44,1.45L243,190.11Zm.1-14s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45-2.05-1.18Zm.62,23.22s0,0,0,0l2.43-1.4,3.29,1.9L247,201.19l-3.28-1.9Zm.62-4a.1.1,0,0,1,0,0l2.43-1.4,6.48,3.74L250.8,199l-6.47-3.74Zm.78-12.7a.05.05,0,0,1,0,0l2.42-1.4,2,1.19-2.44,1.45-2-1.19Zm.8,4.84,0,0,2.42-1.4,2.06,1.19L248,188.59l-2.05-1.19Zm.45,4.65a0,0,0,0,1,0,0l2.43-1.4,2,1.18-2.44,1.45-2-1.18Zm.09-14s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45-2-1.18Zm2,6.49a.05.05,0,0,1,0,0l2.42-1.4,2.06,1.19-2.45,1.45-2.05-1.18Zm.55,17.86a0,0,0,0,1,0,0l2.43-1.41,2,1.19-2.44,1.45-2-1.19Zm.25-13,0,0,2.42-1.4,2,1.19-2.44,1.45-2-1.19Zm.45,4.65a0,0,0,0,1,0,0l2.43-1.4,1.88,1.08a1.53,1.53,0,0,0,1.21,0l3.18-1.84,2.41,1.39-6.24,3.64L249.72,194Zm.09-14s0,0,0,0l2.43-1.4,2.05,1.18-2.44,1.45L249.82,180Zm2,6.49s0,0,0,0l2.42-1.4,2.06,1.18-2.45,1.45-2-1.19Zm.55,17.86a.05.05,0,0,1,0,0l2.42-1.4,2.05,1.19-2.44,1.45-2.05-1.19Zm.25-13,0,0,2.42-1.4,2.06,1.19-2.45,1.45-2.05-1.19Zm2-8.55s0,0,0,0l2.43-1.4,2.05,1.19-2.44,1.45-2.05-1.19Zm.56,5.65a.05.05,0,0,1,0,0l2.42-1.39,2.06,1.18-2.45,1.45-2.05-1.19Zm.55,17.86a.05.05,0,0,1,0,0l2.42-1.4,2.05,1.19-2.44,1.45-2.05-1.19Zm.43-4.14s0,0,0,0l2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18ZM258,184.65s0,0,0,0l2.43-1.4,2.05,1.19-2.44,1.45L258,184.67Zm.55,5.65a.05.05,0,0,1,0,0l2.42-1.39,3.65,2.1-2.45,1.45-3.64-2.11Zm1.26,18.26v0l2.43-1.4,5.41,3.13-2.44,1.45-5.41-3.13Zm.6-12.8a.05.05,0,0,1,0,0l2.42-1.4,2.06,1.19L262.47,197l-2.06-1.18Zm.95-9.17v0l2.43-1.4,2.05,1.19-2.44,1.45-2.05-1.19Zm2.24,19.78a0,0,0,0,1,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.17-8.67a.05.05,0,0,1,0,0l2.42-1.39,2.06,1.18-2.44,1.45-2.05-1.18Zm.44-4.14,0,0,2.42-1.4,2.06,1.19-2.45,1.45-2.05-1.19Zm.51-5v0l2.43-1.4,2,1.19-2.44,1.45-2-1.19Zm1.81,23.91v0L269,211l2,1.19-2.44,1.45-2.05-1.19Zm.43-4.13a0,0,0,0,1,0,0l2.43-1.4,2,1.18L269,209.51l-2-1.18Zm.17-8.67a.05.05,0,0,1,0,0l2.42-1.4,2.06,1.19-2.44,1.45-2.05-1.18Zm.27,4.54s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45-2-1.18Zm.17-8.68,0,0,2.42-1.4,2.06,1.19-2.45,1.45-2.05-1.19Zm1.25-4.6s0,0,0,0l2.42-1.4,2.06,1.19-2.45,1.45-2.05-1.19Zm1.07,23.48s0,0,0,0l6.23-3.59,2.05,1.18-6.24,3.65-2.05-1.19Zm.43-4.13a0,0,0,0,1,0,0l2.43-1.4,2.05,1.18-2.44,1.45-2.05-1.18Zm.44-4.13s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45-2.05-1.18Zm.17-8.68,0,0,2.42-1.4,2.06,1.19L273,198.65l-2.05-1.19Zm.27,4.55s0,0,0,0l2.42-1.41,2.05,1.19-2.44,1.45L271.2,202Zm1-9.15,0,0,2.42-1.4,2.06,1.19-2.45,1.45-2.05-1.19Zm1.94,15.22s0,0,0,0l2.42-1.4,2.06,1.18-2.44,1.45-2.05-1.18Zm.44-4.13s0,0,0,0l2.42-1.41,2.06,1.19-2.45,1.45-2.05-1.19Zm.44-4.14v0l2.43-1.4,2.05,1.19L277.05,201,275,199.81Zm.54-5,0,0,2.42-1.4,2.06,1.19L277.59,196l-2-1.19ZM277.48,210s0,0,0,0l6.22-3.6,2.06,1.19-6.24,3.64L277.49,210Zm.44-4.13s0,0,0,0l2.42-1.41,2.06,1.19L280,207.07l-2.05-1.19Zm.44-4.14s0,0,0,0l2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm2.22-5.16s0,0,0,0l1-.61,2.05,1.18-1.05.66-2-1.18Zm1.14,7.1v0l2.43-1.4,2,1.19-2.44,1.44-2-1.18Zm2.22-5.16s0,0,0,0l1-.61,2.05,1.18-1.05.66-2-1.18Zm1.14,7.1a.1.1,0,0,1,0,0l2.43-1.4,2.05,1.19-2.44,1.44-2.05-1.18Zm2.22-5.16s0,0,0,0l1-.61,2,1.18-1,.66-2-1.18Zm3.36,1.94s0,0,0,0l1-.61,2.05,1.18-1.05.66-2-1.18Z"
                />
              </g>
            </g>
            <g id="Device">
              <polygon
                id="Shadow-6"
                data-name="Shadow"
                className={classes.cls_9}
                points="359.95 210.29 382.9 197.04 268.14 130.78 245.18 144.03 359.95 210.29"
              />
              <g id="Monitor">
                <path
                  className={classes.cls_2}
                  d="M295,188.72l-16.39-9.47c-1.69-1-2.53-2.26-2.53-3.53s0-2.28,0-2.28l15.42-8.76a3.6,3.6,0,0,0,1.63-2.82v-20.2l28.62,16.53V178.4a3.58,3.58,0,0,1-1.64,2.82l-12.88,7.5A13.52,13.52,0,0,1,295,188.72Z"
                />
                <path
                  className={classes.cls_12}
                  d="M314.83,182v2.27l5.25-3a3.62,3.62,0,0,0,1.63-2.82V158.2l-5.45-3.15c-.12,1.38-.24,2.82-.35,4.21l3.82,2.21v15.79a3.57,3.57,0,0,1-1.63,2.82Z"
                />
                <path
                  className={classes.cls_1}
                  d="M319.73,177.26a3.62,3.62,0,0,1-1.63,2.83l-10.9,6.35a13.54,13.54,0,0,1-12.24,0L278.57,177c-3.38-1.95-3.38-5.11,0-7.06l10.91-6.36a3.62,3.62,0,0,0,1.63-2.83V144.93l28.62,16.54Z"
                />
                <path
                  className={classes.cls_13}
                  d="M286.16,165.47h0l3.32-1.91a3.62,3.62,0,0,0,1.63-2.83V144.93l28.62,16.54v15.79a3.62,3.62,0,0,1-1.63,2.83L314.84,182Z"
                />
                <path
                  className={classes.cls_13}
                  d="M276,173.44v2.28c0,1.28.84,2.55,2.53,3.53L295,188.72a12.32,12.32,0,0,0,5.84,1.45V187.9a12.32,12.32,0,0,1-5.84-1.45L278.57,177C276.88,176,276,174.72,276,173.44Z"
                />
                <path
                  className={classes.cls_4}
                  d="M365.69,199.06a4.37,4.37,0,0,1-3.95-.08l-110.69-63.9a4.49,4.49,0,0,1-2-3.53V34.66a3.82,3.82,0,0,1,5.86-3.38l110.69,63.9a4.49,4.49,0,0,1,2,3.53V195.6A4.39,4.39,0,0,1,365.69,199.06Z"
                />
                <path
                  className={classes.cls_3}
                  d="M361.73,199l-110.68-63.9a4.51,4.51,0,0,1-2-3.54V34.66c0-1.3.91-1.83,2-1.18L361.73,97.39a4.49,4.49,0,0,1,2,3.53V197.8C363.77,199.1,362.86,199.63,361.73,199Z"
                />
                <path
                  className={classes.cls_12}
                  d="M362,199.38a3.81,3.81,0,0,0,5.57-3.54V185l-3.82,2.21v10.9C363.78,199.24,363,199.78,362,199.38Z"
                />
                <path
                  className={classes.cls_14}
                  d="M363.77,187.16v10.89c0,1.3-.91,1.83-2,1.18l-110.68-63.9a4.51,4.51,0,0,1-2-3.54V120.9Z"
                />
                <path
                  className={classes.cls_15}
                  d="M360,178.87V102.19a2.7,2.7,0,0,0-1.23-2.12L254.06,39.64c-.68-.39-1.22-.07-1.22.71V117a2.7,2.7,0,0,0,1.23,2.12l104.67,60.42C359.4,180,360,179.65,360,178.87Z"
                />
                <path
                  className={classes.cls_16}
                  d="M360,178.87V102.19a2.7,2.7,0,0,0-1.23-2.12L254.06,39.64c-.68-.39-1.22-.07-1.22.71V117a2.7,2.7,0,0,0,1.23,2.12l104.67,60.42C359.4,180,360,179.65,360,178.87Z"
                />
                <path
                  className={classes.cls_4}
                  d="M306.39,158.19a4.24,4.24,0,0,1,1.92,3.32c0,1.22-.86,1.71-1.92,1.1a4.24,4.24,0,0,1-1.91-3.31C304.48,158.08,305.34,157.58,306.39,158.19Z"
                />
                <path
                  className={classes.cls_10}
                  d="M363.17,98.9a4.33,4.33,0,0,1,.61,2v86.24L367.6,185V98.71a4.28,4.28,0,0,0-.6-2Z"
                />
              </g>
            </g>
            <motion.g variants={code2Variants} animate="end" id="Window">
              <g id="Window-2" data-name="Window">
                <path
                  className={classes.cls_4}
                  d="M267.12,14.66a.52.52,0,0,1,0-.18s0,0,0,0a.47.47,0,0,1,0-.17,1,1,0,0,1,.12-.25.6.6,0,0,1,.06-.11s0-.05.06-.07a.49.49,0,0,1,.13-.12v0a.56.56,0,0,1,.17-.09,1.42,1.42,0,0,1,1.31.16L398.23,88.32a4.32,4.32,0,0,1,2,3.38v93.94a1.32,1.32,0,0,1-.71,1.17l-.08.05-.1.06a.49.49,0,0,1-.17.06,1.07,1.07,0,0,1-.25,0,1.31,1.31,0,0,1-.65-.18l-.05,0h0l-1.86-1.08L269.06,112.25a4.29,4.29,0,0,1-1.95-3.38v-94A1.85,1.85,0,0,1,267.12,14.66Z"
                />
                <path
                  className={classes.cls_15}
                  d="M267.75,13.61a1.42,1.42,0,0,1,1.31.16L398.23,88.32a4.32,4.32,0,0,1,2,3.38v6.38l2.49-1.46V90.29a4.29,4.29,0,0,0-1.95-3.38L271.55,12.36a1.36,1.36,0,0,0-1.41-.11C269.78,12.46,268.16,13.39,267.75,13.61Z"
                />
                <path
                  className={classes.cls_11}
                  d="M267.11,14.89c0-1.23.88-1.73,1.95-1.11L398.23,88.32a4.32,4.32,0,0,1,2,3.38v6.38L267.11,21.29Z"
                />
                <g className={classes.cls_17}>
                  <path
                    className={classes.cls_14}
                    d="M269.06,13.78,398.23,88.32a3.94,3.94,0,0,1,1.38,1.45l2.48-1.44a3.88,3.88,0,0,0-1.36-1.42L271.55,12.36a1.37,1.37,0,0,0-1.42-.11c-.35.21-2,1.13-2.38,1.35A1.43,1.43,0,0,1,269.06,13.78Z"
                  />
                </g>
                <path
                  className={classes.cls_9}
                  d="M402.68,96.63V90.28a4,4,0,0,0-.59-2l-2.49,1.43a4,4,0,0,1,.58,1.94v6.38Z"
                />
                <path
                  className={classes.cls_4}
                  d="M395.79,89.67a2.92,2.92,0,0,1,1.1,2.33c0,.94-.5,1.41-1.1,1.06a2.9,2.9,0,0,1-1.11-2.33C394.68,89.79,395.18,89.32,395.79,89.67Z"
                />
                <path
                  className={classes.cls_4}
                  d="M391.82,87.37a2.94,2.94,0,0,1,1.1,2.34c0,.93-.5,1.41-1.1,1.06a2.92,2.92,0,0,1-1.11-2.34C390.71,87.5,391.21,87,391.82,87.37Z"
                />
                <path
                  className={classes.cls_4}
                  d="M387.85,85.08a2.89,2.89,0,0,1,1.1,2.33c0,.94-.49,1.41-1.1,1.06a2.9,2.9,0,0,1-1.11-2.33C386.74,85.2,387.24,84.73,387.85,85.08Z"
                />
                <path
                  className={classes.cls_18}
                  d="M399.49,186.82l.1-.06,2.05-1.19a2.07,2.07,0,0,0,1-1.51,1.42,1.42,0,0,0,0-.29V96.62l-2.49,1.46v87.55a1.28,1.28,0,0,1-.61,1.11l-.06,0h0Z"
                />
              </g>
              <g id="Code">
                <path
                  className={classes.cls_19}
                  d="M306.68,54.56l27.23,15.7a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35L306.68,56.07a1.5,1.5,0,0,1-.7-1.16C306,54.5,306.29,54.34,306.68,54.56Z"
                />
                <path
                  className={classes.cls_2}
                  d="M317.08,84.6l10.33,5.94a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-10.33-5.93a1.49,1.49,0,0,1-.69-1.15C316.39,84.54,316.7,84.38,317.08,84.6Z"
                />
                <path
                  className={classes.cls_2}
                  d="M317.08,90.61l10.33,5.94a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-10.33-5.93a1.51,1.51,0,0,1-.69-1.16C316.39,90.55,316.7,90.39,317.08,90.61Z"
                />
                <path
                  className={classes.cls_19}
                  d="M336.6,71.81l54.52,31.4a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35L336.6,73.31a1.49,1.49,0,0,1-.69-1.15C335.91,71.74,336.22,71.59,336.6,71.81Z"
                />
                <path
                  className={classes.cls_19}
                  d="M317.31,126.74l16.6,9.6a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.36l-16.6-9.61a1.53,1.53,0,0,1-.7-1.15C316.61,126.67,316.93,126.52,317.31,126.74Z"
                />
                <path
                  className={classes.cls_19}
                  d="M336.6,137.89l54.52,31.44a1.5,1.5,0,0,1,.7,1.16c0,.41-.31.57-.7.35L336.6,139.4a1.5,1.5,0,0,1-.69-1.16C335.91,137.83,336.22,137.67,336.6,137.89Z"
                />
                <path
                  className={classes.cls_11}
                  d="M306.68,60.59l13.71,7.88a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-13.71-7.88a1.48,1.48,0,0,1-.7-1.15C306,60.52,306.29,60.36,306.68,60.59Z"
                />
                <path
                  className={classes.cls_20}
                  d="M306.68,60.59l13.71,7.88a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-13.71-7.88a1.48,1.48,0,0,1-.7-1.15C306,60.52,306.29,60.36,306.68,60.59Z"
                />
                <path
                  className={classes.cls_11}
                  d="M306.68,66.58l6.42,3.7a1.5,1.5,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-6.42-3.71a1.46,1.46,0,0,1-.7-1.15C306,66.52,306.29,66.36,306.68,66.58Z"
                />
                <path
                  className={classes.cls_20}
                  d="M306.68,66.58l6.42,3.7a1.5,1.5,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-6.42-3.71a1.46,1.46,0,0,1-.7-1.15C306,66.52,306.29,66.36,306.68,66.58Z"
                />
                <path
                  className={classes.cls_11}
                  d="M306.68,78.6l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-6.42-3.7A1.48,1.48,0,0,1,306,79C306,78.53,306.29,78.38,306.68,78.6Z"
                />
                <path
                  className={classes.cls_20}
                  d="M306.68,78.6l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-6.42-3.7A1.48,1.48,0,0,1,306,79C306,78.53,306.29,78.38,306.68,78.6Z"
                />
                <path
                  className={classes.cls_11}
                  d="M306.68,84.61l6.42,3.7a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-6.42-3.7A1.48,1.48,0,0,1,306,85C306,84.54,306.29,84.39,306.68,84.61Z"
                />
                <path
                  className={classes.cls_20}
                  d="M306.68,84.61l6.42,3.7a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-6.42-3.7A1.48,1.48,0,0,1,306,85C306,84.54,306.29,84.39,306.68,84.61Z"
                />
                <path
                  className={classes.cls_11}
                  d="M323.08,70l8.23,4.76a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-8.23-4.77a1.49,1.49,0,0,1-.69-1.15C322.39,70,322.7,69.8,323.08,70Z"
                />
                <path
                  className={classes.cls_20}
                  d="M323.08,70l8.23,4.76a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-8.23-4.77a1.49,1.49,0,0,1-.69-1.15C322.39,70,322.7,69.8,323.08,70Z"
                />
                <path
                  className={classes.cls_14}
                  d="M335.8,113.45l55.32,31.85a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.58-.7.36L335.8,115a1.51,1.51,0,0,1-.69-1.16C335.11,113.39,335.42,113.23,335.8,113.45Z"
                />
                <path
                  className={classes.cls_14}
                  d="M382.9,134.52l8.22,4.77a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35L382.9,136a1.46,1.46,0,0,1-.7-1.15C382.2,134.46,382.51,134.3,382.9,134.52Z"
                />
                <path
                  className={classes.cls_14}
                  d="M324.89,101.12,380.21,133a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-55.32-31.85a1.48,1.48,0,0,1-.69-1.15C324.2,101.06,324.51,100.9,324.89,101.12Z"
                />
                <path
                  className={classes.cls_11}
                  d="M317.08,72.59l13.72,7.88a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.36l-13.72-7.89a1.48,1.48,0,0,1-.69-1.15C316.39,72.53,316.7,72.37,317.08,72.59Z"
                />
                <path
                  className={classes.cls_20}
                  d="M317.08,72.59l13.72,7.88a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.36l-13.72-7.89a1.48,1.48,0,0,1-.69-1.15C316.39,72.53,316.7,72.37,317.08,72.59Z"
                />
                <path
                  className={classes.cls_11}
                  d="M333.49,82l57.22,33.11a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35l-57.22-33.1a1.49,1.49,0,0,1-.69-1.15C332.8,82,333.11,81.8,333.49,82Z"
                />
                <path
                  className={classes.cls_20}
                  d="M333.49,82l57.22,33.11a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35l-57.22-33.1a1.49,1.49,0,0,1-.69-1.15C332.8,82,333.11,81.8,333.49,82Z"
                />
                <path
                  className={classes.cls_2}
                  d="M317.08,108.76l74,42.7a1.46,1.46,0,0,1,.7,1.15c0,.41-.31.57-.7.35l-74-42.7a1.48,1.48,0,0,1-.69-1.15C316.39,108.7,316.7,108.54,317.08,108.76Z"
                />
                <path
                  className={classes.cls_11}
                  d="M306.68,102.76l6.42,3.7a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-6.42-3.7a1.48,1.48,0,0,1-.7-1.15C306,102.69,306.29,102.53,306.68,102.76Z"
                />
                <path
                  className={classes.cls_20}
                  d="M306.68,102.76l6.42,3.7a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-6.42-3.7a1.48,1.48,0,0,1-.7-1.15C306,102.69,306.29,102.53,306.68,102.76Z"
                />
                <path
                  className={classes.cls_2}
                  d="M317.08,114.77l74,42.69a1.5,1.5,0,0,1,.7,1.16c0,.41-.31.57-.7.35l-74-42.7a1.49,1.49,0,0,1-.69-1.15C316.39,114.7,316.7,114.55,317.08,114.77Z"
                />
                <path
                  className={classes.cls_11}
                  d="M306.68,108.76l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-6.42-3.7a1.46,1.46,0,0,1-.7-1.15C306,108.7,306.29,108.54,306.68,108.76Z"
                />
                <path
                  className={classes.cls_20}
                  d="M306.68,108.76l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-6.42-3.7a1.46,1.46,0,0,1-.7-1.15C306,108.7,306.29,108.54,306.68,108.76Z"
                />
                <path
                  className={classes.cls_2}
                  d="M317.08,120.77l74,42.7a1.48,1.48,0,0,1,.7,1.15c0,.42-.31.57-.7.35l-74-42.69a1.51,1.51,0,0,1-.69-1.16C316.39,120.71,316.7,120.55,317.08,120.77Z"
                />
                <path
                  className={classes.cls_11}
                  d="M306.68,114.77l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-6.42-3.7a1.48,1.48,0,0,1-.7-1.15C306,114.7,306.29,114.55,306.68,114.77Z"
                />
                <path
                  className={classes.cls_20}
                  d="M306.68,114.77l6.42,3.7a1.49,1.49,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-6.42-3.7a1.48,1.48,0,0,1-.7-1.15C306,114.7,306.29,114.55,306.68,114.77Z"
                />
                <g className={classes.cls_21}>
                  <path
                    className={classes.cls_14}
                    d="M296.67,48.54l3.77,2.18a1.52,1.52,0,0,1,.69,1.18v1.39c0,.44-.31.62-.69.4l-3.77-2.18a1.51,1.51,0,0,1-.68-1.19V48.94C296,48.5,296.29,48.32,296.67,48.54Z"
                  />
                  <path
                    className={classes.cls_14}
                    d="M296.67,54.6l3.77,2.18a1.52,1.52,0,0,1,.69,1.19v1.39c0,.43-.31.61-.69.39l-3.77-2.18a1.49,1.49,0,0,1-.68-1.18V55C296,54.56,296.29,54.39,296.67,54.6Z"
                  />
                  <path
                    className={classes.cls_14}
                    d="M296.67,60.67l3.77,2.18a1.52,1.52,0,0,1,.69,1.18v1.39c0,.44-.31.61-.69.4l-3.77-2.18a1.51,1.51,0,0,1-.68-1.19V61.06C296,60.63,296.29,60.45,296.67,60.67Z"
                  />
                  <path
                    className={classes.cls_14}
                    d="M296.67,66.73l3.77,2.18a1.52,1.52,0,0,1,.69,1.19v1.39c0,.43-.31.61-.69.39l-3.77-2.18a1.51,1.51,0,0,1-.68-1.18V67.13C296,66.69,296.29,66.52,296.67,66.73Z"
                  />
                  <path
                    className={classes.cls_14}
                    d="M296.67,72.8,300.44,75a1.5,1.5,0,0,1,.69,1.18v1.39c0,.44-.31.61-.69.4l-3.77-2.18a1.51,1.51,0,0,1-.68-1.19V73.19C296,72.76,296.29,72.58,296.67,72.8Z"
                  />
                  <path
                    className={classes.cls_14}
                    d="M296.67,78.86,300.44,81a1.52,1.52,0,0,1,.69,1.19v1.38c0,.44-.31.62-.69.4l-3.77-2.18a1.51,1.51,0,0,1-.68-1.18V79.26C296,78.82,296.29,78.64,296.67,78.86Z"
                  />
                  <path
                    className={classes.cls_14}
                    d="M296.67,84.93l3.77,2.18a1.5,1.5,0,0,1,.69,1.18v1.39c0,.44-.31.61-.69.4l-3.77-2.18a1.51,1.51,0,0,1-.68-1.19V85.32C296,84.89,296.29,84.71,296.67,84.93Z"
                  />
                  <path
                    className={classes.cls_14}
                    d="M296.67,91l3.77,2.18a1.52,1.52,0,0,1,.69,1.19v1.38c0,.44-.31.62-.69.4L296.67,94a1.51,1.51,0,0,1-.68-1.18V91.39C296,91,296.29,90.77,296.67,91Z"
                  />
                  <path
                    className={classes.cls_14}
                    d="M296.67,97.06l3.77,2.18a1.5,1.5,0,0,1,.69,1.18v1.39c0,.44-.31.61-.69.39L296.67,100a1.51,1.51,0,0,1-.68-1.19V97.45C296,97,296.29,96.84,296.67,97.06Z"
                  />
                  <path
                    className={classes.cls_14}
                    d="M296.67,103.12l3.77,2.18a1.52,1.52,0,0,1,.69,1.19v1.38c0,.44-.31.62-.69.4l-3.77-2.18a1.51,1.51,0,0,1-.68-1.19v-1.38C296,103.08,296.29,102.9,296.67,103.12Z"
                  />
                  <path
                    className={classes.cls_14}
                    d="M296.67,109.19l3.77,2.17a1.52,1.52,0,0,1,.69,1.19v1.39c0,.44-.31.61-.69.39l-3.77-2.17A1.51,1.51,0,0,1,296,111v-1.39C296,109.15,296.29,109,296.67,109.19Z"
                  />
                  <path
                    className={classes.cls_14}
                    d="M296.67,115.25l3.77,2.18a1.52,1.52,0,0,1,.69,1.19V120c0,.44-.31.62-.69.4l-3.77-2.18A1.51,1.51,0,0,1,296,117v-1.38C296,115.21,296.29,115,296.67,115.25Z"
                  />
                </g>
                <path
                  className={classes.cls_3}
                  d="M271.65,28.84l20.4,11.78A3,3,0,0,1,293.42,43V66.55c0,.87-.62,1.22-1.37.79l-20.4-11.78a3,3,0,0,1-1.37-2.38V29.63C270.28,28.76,270.89,28.4,271.65,28.84Z"
                />
                <path
                  className={classes.cls_15}
                  d="M273.54,52.19l1.88,1.08a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.49,1.49,0,0,1-.69-1.15C272.85,52.12,273.16,52,273.54,52.19Z"
                />
                <path
                  className={classes.cls_20}
                  d="M273.54,52.19l1.88,1.08a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.49,1.49,0,0,1-.69-1.15C272.85,52.12,273.16,52,273.54,52.19Z"
                />
                <path
                  className={classes.cls_15}
                  d="M273.54,32.9,275.42,34a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.49,1.49,0,0,1-.69-1.15C272.85,32.83,273.16,32.68,273.54,32.9Z"
                />
                <path
                  className={classes.cls_20}
                  d="M273.54,32.9,275.42,34a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.49,1.49,0,0,1-.69-1.15C272.85,32.83,273.16,32.68,273.54,32.9Z"
                />
                <path
                  className={classes.cls_15}
                  d="M276.18,38.27l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C275.49,38.21,275.8,38.05,276.18,38.27Z"
                />
                <path
                  className={classes.cls_20}
                  d="M276.18,38.27l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C275.49,38.21,275.8,38.05,276.18,38.27Z"
                />
                <path
                  className={classes.cls_15}
                  d="M276.18,42.12l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C275.49,42.06,275.8,41.9,276.18,42.12Z"
                />
                <path
                  className={classes.cls_20}
                  d="M276.18,42.12l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C275.49,42.06,275.8,41.9,276.18,42.12Z"
                />
                <path
                  className={classes.cls_15}
                  d="M273.54,44.47l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35L273.54,46a1.48,1.48,0,0,1-.69-1.15C272.85,44.41,273.16,44.25,273.54,44.47Z"
                />
                <path
                  className={classes.cls_20}
                  d="M273.54,44.47l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35L273.54,46a1.48,1.48,0,0,1-.69-1.15C272.85,44.41,273.16,44.25,273.54,44.47Z"
                />
                <path
                  className={classes.cls_15}
                  d="M276.18,49.85l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C275.49,49.78,275.8,49.63,276.18,49.85Z"
                />
                <path
                  className={classes.cls_20}
                  d="M276.18,49.85l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C275.49,49.78,275.8,49.63,276.18,49.85Z"
                />
                <path
                  className={classes.cls_22}
                  d="M278.68,35.87l11.47,6.62a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-11.47-6.62a1.49,1.49,0,0,1-.69-1.15C278,35.81,278.3,35.65,278.68,35.87Z"
                />
                <path
                  className={classes.cls_23}
                  d="M278.68,35.87l11.47,6.62a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-11.47-6.62a1.49,1.49,0,0,1-.69-1.15C278,35.81,278.3,35.65,278.68,35.87Z"
                />
                <path
                  className={classes.cls_22}
                  d="M278.68,55.16l11.47,6.62a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-11.47-6.62a1.49,1.49,0,0,1-.69-1.15C278,55.09,278.3,54.94,278.68,55.16Z"
                />
                <path
                  className={classes.cls_23}
                  d="M278.68,55.16l11.47,6.62a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-11.47-6.62a1.49,1.49,0,0,1-.69-1.15C278,55.09,278.3,54.94,278.68,55.16Z"
                />
                <path
                  className={classes.cls_22}
                  d="M281.32,41.24l8.83,5.11a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-8.83-5.11a1.48,1.48,0,0,1-.69-1.15C280.63,41.18,280.94,41,281.32,41.24Z"
                />
                <path
                  className={classes.cls_23}
                  d="M281.32,41.24l8.83,5.11a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-8.83-5.11a1.48,1.48,0,0,1-.69-1.15C280.63,41.18,280.94,41,281.32,41.24Z"
                />
                <path
                  className={classes.cls_22}
                  d="M281.32,45.1l8.83,5.11a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-8.83-5.11a1.48,1.48,0,0,1-.69-1.15C280.63,45,280.94,44.88,281.32,45.1Z"
                />
                <path
                  className={classes.cls_23}
                  d="M281.32,45.1l8.83,5.11a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-8.83-5.11a1.48,1.48,0,0,1-.69-1.15C280.63,45,280.94,44.88,281.32,45.1Z"
                />
                <path
                  className={classes.cls_22}
                  d="M278.68,47.44l11.47,6.62a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35L278.68,49a1.51,1.51,0,0,1-.69-1.16C278,47.38,278.3,47.22,278.68,47.44Z"
                />
                <path
                  className={classes.cls_23}
                  d="M278.68,47.44l11.47,6.62a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35L278.68,49a1.51,1.51,0,0,1-.69-1.16C278,47.38,278.3,47.22,278.68,47.44Z"
                />
                <path
                  className={classes.cls_22}
                  d="M281.32,52.82l8.83,5.1a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-8.83-5.1a1.49,1.49,0,0,1-.69-1.15C280.63,52.75,280.94,52.6,281.32,52.82Z"
                />
                <path
                  className={classes.cls_23}
                  d="M281.32,52.82l8.83,5.1a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-8.83-5.1a1.49,1.49,0,0,1-.69-1.15C280.63,52.75,280.94,52.6,281.32,52.82Z"
                />
                <path
                  className={classes.cls_3}
                  d="M271.65,60l20.4,11.78a3,3,0,0,1,1.37,2.37v46.55c0,.87-.62,1.22-1.37.79l-20.4-11.78a3,3,0,0,1-1.37-2.37V60.78C270.28,59.91,270.89,59.55,271.65,60Z"
                />
                <path
                  className={classes.cls_15}
                  d="M273.54,64.05l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C272.85,64,273.16,63.83,273.54,64.05Z"
                />
                <path
                  className={classes.cls_20}
                  d="M273.54,64.05l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C272.85,64,273.16,63.83,273.54,64.05Z"
                />
                <path
                  className={classes.cls_15}
                  d="M276.18,69.42l1.88,1.09a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.51,1.51,0,0,1-.69-1.16C275.49,69.36,275.8,69.2,276.18,69.42Z"
                />
                <path
                  className={classes.cls_20}
                  d="M276.18,69.42l1.88,1.09a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.51,1.51,0,0,1-.69-1.16C275.49,69.36,275.8,69.2,276.18,69.42Z"
                />
                <path
                  className={classes.cls_15}
                  d="M276.18,73.27l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C275.49,73.21,275.8,73.05,276.18,73.27Z"
                />
                <path
                  className={classes.cls_20}
                  d="M276.18,73.27l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C275.49,73.21,275.8,73.05,276.18,73.27Z"
                />
                <path
                  className={classes.cls_15}
                  d="M273.54,75.62l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C272.85,75.56,273.16,75.4,273.54,75.62Z"
                />
                <path
                  className={classes.cls_20}
                  d="M273.54,75.62l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C272.85,75.56,273.16,75.4,273.54,75.62Z"
                />
                <path
                  className={classes.cls_24}
                  d="M278.68,67l11.47,6.62a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-11.47-6.62a1.48,1.48,0,0,1-.69-1.15C278,67,278.3,66.8,278.68,67Z"
                />
                <path
                  className={classes.cls_23}
                  d="M278.68,67l11.47,6.62a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-11.47-6.62a1.48,1.48,0,0,1-.69-1.15C278,67,278.3,66.8,278.68,67Z"
                />
                <path
                  className={classes.cls_24}
                  d="M281.32,72.39l8.83,5.11a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-8.83-5.1a1.51,1.51,0,0,1-.69-1.16C280.63,72.33,280.94,72.17,281.32,72.39Z"
                />
                <path
                  className={classes.cls_23}
                  d="M281.32,72.39l8.83,5.11a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-8.83-5.1a1.51,1.51,0,0,1-.69-1.16C280.63,72.33,280.94,72.17,281.32,72.39Z"
                />
                <path
                  className={classes.cls_24}
                  d="M281.32,76.25l8.83,5.11a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-8.83-5.11a1.48,1.48,0,0,1-.69-1.15C280.63,76.19,280.94,76,281.32,76.25Z"
                />
                <path
                  className={classes.cls_23}
                  d="M281.32,76.25l8.83,5.11a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-8.83-5.11a1.48,1.48,0,0,1-.69-1.15C280.63,76.19,280.94,76,281.32,76.25Z"
                />
                <path
                  className={classes.cls_24}
                  d="M278.68,78.59l11.47,6.63a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35L278.68,80.1A1.49,1.49,0,0,1,278,79C278,78.53,278.3,78.37,278.68,78.59Z"
                />
                <path
                  className={classes.cls_23}
                  d="M278.68,78.59l11.47,6.63a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35L278.68,80.1A1.49,1.49,0,0,1,278,79C278,78.53,278.3,78.37,278.68,78.59Z"
                />
                <path
                  className={classes.cls_15}
                  d="M276.18,81l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C275.49,81,275.8,80.8,276.18,81Z"
                />
                <path
                  className={classes.cls_20}
                  d="M276.18,81l1.88,1.09a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-1.88-1.09a1.48,1.48,0,0,1-.69-1.15C275.49,81,275.8,80.8,276.18,81Z"
                />
                <path
                  className={classes.cls_15}
                  d="M276.18,84.87,278.06,86a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.49,1.49,0,0,1-.69-1.15C275.49,84.8,275.8,84.65,276.18,84.87Z"
                />
                <path
                  className={classes.cls_20}
                  d="M276.18,84.87,278.06,86a1.51,1.51,0,0,1,.69,1.16c0,.41-.31.57-.69.35l-1.88-1.09a1.49,1.49,0,0,1-.69-1.15C275.49,84.8,275.8,84.65,276.18,84.87Z"
                />
                <path
                  className={classes.cls_24}
                  d="M281.32,84l8.83,5.11a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-8.83-5.11a1.48,1.48,0,0,1-.69-1.15C280.63,83.93,280.94,83.77,281.32,84Z"
                />
                <path
                  className={classes.cls_23}
                  d="M281.32,84l8.83,5.11a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-8.83-5.11a1.48,1.48,0,0,1-.69-1.15C280.63,83.93,280.94,83.77,281.32,84Z"
                />
                <path
                  className={classes.cls_24}
                  d="M281.32,87.85,290.15,93a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-8.83-5.11a1.49,1.49,0,0,1-.69-1.15C280.63,87.78,280.94,87.63,281.32,87.85Z"
                />
                <path
                  className={classes.cls_23}
                  d="M281.32,87.85,290.15,93a1.48,1.48,0,0,1,.69,1.15c0,.41-.31.57-.69.35l-8.83-5.11a1.49,1.49,0,0,1-.69-1.15C280.63,87.78,280.94,87.63,281.32,87.85Z"
                />
                <path
                  className={classes.cls_5}
                  d="M273.54,95,275.42,96a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C272.85,94.89,273.16,94.74,273.54,95Z"
                />
                <path
                  className={classes.cls_20}
                  d="M273.54,95,275.42,96a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C272.85,94.89,273.16,94.74,273.54,95Z"
                />
                <path
                  className={classes.cls_24}
                  d="M278.68,97.93l11.47,6.62a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-11.47-6.62a1.48,1.48,0,0,1-.69-1.15C278,97.87,278.3,97.71,278.68,97.93Z"
                />
                <path
                  className={classes.cls_23}
                  d="M278.68,97.93l11.47,6.62a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-11.47-6.62a1.48,1.48,0,0,1-.69-1.15C278,97.87,278.3,97.71,278.68,97.93Z"
                />
                <path
                  className={classes.cls_15}
                  d="M276.18,100.36l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C275.49,100.29,275.8,100.13,276.18,100.36Z"
                />
                <path
                  className={classes.cls_20}
                  d="M276.18,100.36l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C275.49,100.29,275.8,100.13,276.18,100.36Z"
                />
                <path
                  className={classes.cls_15}
                  d="M276.18,104.2l1.88,1.09a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.5,1.5,0,0,1-.69-1.16C275.49,104.14,275.8,104,276.18,104.2Z"
                />
                <path
                  className={classes.cls_20}
                  d="M276.18,104.2l1.88,1.09a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.5,1.5,0,0,1-.69-1.16C275.49,104.14,275.8,104,276.18,104.2Z"
                />
                <path
                  className={classes.cls_24}
                  d="M281.32,103.33l8.83,5.1a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.36l-8.83-5.11a1.49,1.49,0,0,1-.69-1.15C280.63,103.26,280.94,103.1,281.32,103.33Z"
                />
                <path
                  className={classes.cls_23}
                  d="M281.32,103.33l8.83,5.1a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.36l-8.83-5.11a1.49,1.49,0,0,1-.69-1.15C280.63,103.26,280.94,103.1,281.32,103.33Z"
                />
                <path
                  className={classes.cls_24}
                  d="M281.32,107.18l8.83,5.11a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-8.83-5.1a1.51,1.51,0,0,1-.69-1.16C280.63,107.12,280.94,107,281.32,107.18Z"
                />
                <path
                  className={classes.cls_23}
                  d="M281.32,107.18l8.83,5.11a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-8.83-5.1a1.51,1.51,0,0,1-.69-1.16C280.63,107.12,280.94,107,281.32,107.18Z"
                />
                <path
                  className={classes.cls_15}
                  d="M276.18,88.7l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C275.49,88.63,275.8,88.47,276.18,88.7Z"
                />
                <path
                  className={classes.cls_20}
                  d="M276.18,88.7l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C275.49,88.63,275.8,88.47,276.18,88.7Z"
                />
                <path
                  className={classes.cls_15}
                  d="M273.54,91.05l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C272.85,91,273.16,90.82,273.54,91.05Z"
                />
                <path
                  className={classes.cls_20}
                  d="M273.54,91.05l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-1.88-1.08a1.49,1.49,0,0,1-.69-1.15C272.85,91,273.16,90.82,273.54,91.05Z"
                />
                <path
                  className={classes.cls_24}
                  d="M281.32,91.68l8.83,5.1a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-8.83-5.1a1.49,1.49,0,0,1-.69-1.15C280.63,91.61,280.94,91.45,281.32,91.68Z"
                />
                <path
                  className={classes.cls_23}
                  d="M281.32,91.68l8.83,5.1a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-8.83-5.1a1.49,1.49,0,0,1-.69-1.15C280.63,91.61,280.94,91.45,281.32,91.68Z"
                />
                <path
                  className={classes.cls_24}
                  d="M278.68,94l11.47,6.62a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-11.47-6.62a1.49,1.49,0,0,1-.69-1.15C278,94,278.3,93.8,278.68,94Z"
                />
                <path
                  className={classes.cls_23}
                  d="M278.68,94l11.47,6.62a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.57-.69.35l-11.47-6.62a1.49,1.49,0,0,1-.69-1.15C278,94,278.3,93.8,278.68,94Z"
                />
                <path
                  className={classes.cls_15}
                  d="M273.54,106.61l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.36l-1.88-1.09a1.49,1.49,0,0,1-.69-1.15C272.85,106.54,273.16,106.39,273.54,106.61Z"
                />
                <path
                  className={classes.cls_20}
                  d="M273.54,106.61l1.88,1.08a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.36l-1.88-1.09a1.49,1.49,0,0,1-.69-1.15C272.85,106.54,273.16,106.39,273.54,106.61Z"
                />
                <path
                  className={classes.cls_24}
                  d="M278.68,109.58l11.47,6.62a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-11.47-6.62a1.48,1.48,0,0,1-.69-1.15C278,109.52,278.3,109.36,278.68,109.58Z"
                />
                <path
                  className={classes.cls_23}
                  d="M278.68,109.58l11.47,6.62a1.49,1.49,0,0,1,.69,1.15c0,.42-.31.58-.69.35l-11.47-6.62a1.48,1.48,0,0,1-.69-1.15C278,109.52,278.3,109.36,278.68,109.58Z"
                />
              </g>
            </motion.g>
            <motion.g
              variants={codeVariants}
              animate="end"
              id="Window-3"
              data-name="Window"
            >
              <g className={classes.cls_25}>
                <path
                  className={classes.cls_4}
                  d="M385.15,125.42V201.8a3.51,3.51,0,0,0,1.59,2.75l43.88,25.31a.91.91,0,0,0,.52.15l.21,0,.13-.05.08-.05.1-.06.09-.08a1.22,1.22,0,0,0,.29-.41,2.09,2.09,0,0,0,.16-.81v-76a3.53,3.53,0,0,0-1.58-2.75L386.74,124.5a1.15,1.15,0,0,0-1.07-.13.35.35,0,0,0-.13.08h0a.36.36,0,0,0-.11.1l-.05.06a.22.22,0,0,0-.05.08.72.72,0,0,0-.09.2.74.74,0,0,0,0,.14s0,0,0,0a.58.58,0,0,0,0,.14C385.16,125.28,385.15,125.35,385.15,125.42Z"
                />
              </g>
              <path
                className={classes.cls_15}
                d="M385.67,124.37a1.15,1.15,0,0,1,1.07.13l43.88,25.29a3.53,3.53,0,0,1,1.58,2.75v5.19l2.53-1.46v-5.15a3.5,3.5,0,0,0-1.58-2.75l-43.88-25.29a1.11,1.11,0,0,0-1.15-.09C387.83,123.16,386,124.19,385.67,124.37Z"
              />
              <path
                className={classes.cls_11}
                d="M385.15,125.41c0-1,.72-1.41,1.59-.9l43.88,25.29a3.5,3.5,0,0,1,1.58,2.74v5.19l-47.05-27.12Z"
              />
              <g className={classes.cls_17}>
                <path
                  className={classes.cls_14}
                  d="M386.74,124.5l43.88,25.29a3.33,3.33,0,0,1,1.11,1.18l2.52-1.44a3.16,3.16,0,0,0-1.1-1.16l-43.88-25.29a1.11,1.11,0,0,0-1.15-.09c-.29.17-2.11,1.2-2.44,1.37A1.17,1.17,0,0,1,386.74,124.5Z"
                />
              </g>
              <path
                className={classes.cls_9}
                d="M434.74,156.27v-5.15a3.19,3.19,0,0,0-.48-1.59L431.73,151a3.24,3.24,0,0,1,.47,1.57v5.19Z"
              />
              <path
                className={classes.cls_4}
                d="M429.9,151.93a2.36,2.36,0,0,1,.89,1.9c0,.76-.4,1.14-.89.86a2.37,2.37,0,0,1-.9-1.9C429,152,429.4,151.64,429.9,151.93Z"
              />
              <path
                className={classes.cls_4}
                d="M426.67,150.06a2.37,2.37,0,0,1,.9,1.9c0,.76-.4,1.15-.9.86a2.37,2.37,0,0,1-.9-1.9C425.77,150.16,426.18,149.78,426.67,150.06Z"
              />
              <path
                className={classes.cls_4}
                d="M423.44,148.2a2.33,2.33,0,0,1,.9,1.89c0,.77-.4,1.15-.9.87a2.39,2.39,0,0,1-.89-1.9C422.55,148.3,423,147.91,423.44,148.2Z"
              />
              <g className={classes.cls_26}>
                <path
                  className={classes.cls_3}
                  d="M431.62,229.87l.2-.12.49-.27h0l.27-.15h0l.42-.24.85-.47a1.1,1.1,0,0,1,.2-.11.93.93,0,0,0,.27-.22,1.48,1.48,0,0,0,.21-.32,1.89,1.89,0,0,0,.18-.84V156.27l-2.53,1.46v70.8a2.38,2.38,0,0,1-.16.81,1.22,1.22,0,0,1-.29.41.34.34,0,0,1-.09.08Z"
                />
              </g>
              <path
                className={classes.cls_19}
                d="M388.8,139.38a.23.23,0,0,1,.08-.21l1.14-1s0,0,.05,0h0a.35.35,0,0,1,.09.11.53.53,0,0,1,0,.16v.8a.51.51,0,0,1,0,.21.26.26,0,0,1-.08.13l-.6.55.6,1.24a1,1,0,0,1,.08.22.81.81,0,0,1,0,.25v.79a.21.21,0,0,1,0,.12.07.07,0,0,1-.09,0l0,0s0,0-.05-.07l-1.14-2.36a.56.56,0,0,1-.08-.3Z"
              />
              <path
                className={classes.cls_19}
                d="M393,138.28a.34.34,0,0,1,.09-.14s.09,0,.16,0l.43.25a.2.2,0,0,1,.09.11.34.34,0,0,1,0,.16s0,.05,0,.08l-2,6.07a.22.22,0,0,1-.08.13s-.1,0-.17,0l-.41-.23a.2.2,0,0,1-.09-.11.34.34,0,0,1,0-.16.22.22,0,0,1,0-.08Z"
              />
              <path
                className={classes.cls_19}
                d="M396,144.12a.22.22,0,0,1-.08.2l-1.14,1.05h0l0,0a.26.26,0,0,1-.09-.11.41.41,0,0,1,0-.16v-.79a.65.65,0,0,1,0-.22.28.28,0,0,1,.08-.12l.6-.55-.6-1.25a.74.74,0,0,1-.08-.22.82.82,0,0,1,0-.24v-.79a.19.19,0,0,1,0-.12.1.1,0,0,1,.09,0l0,0s0,0,0,.07l1.14,2.36a.55.55,0,0,1,.08.29Z"
              />
              <path
                className={classes.cls_19}
                d="M399.16,147.23a.27.27,0,0,1,.11.14.34.34,0,0,1,.05.19v.88a.16.16,0,0,1-.05.14s-.06,0-.11,0l-.53-.31a.27.27,0,0,1-.11-.14.45.45,0,0,1,0-.19v-.88a.2.2,0,0,1,0-.14s.06,0,.11,0Z"
              />
              <path
                className={classes.cls_19}
                d="M401,148.27a.27.27,0,0,1,.11.14.34.34,0,0,1,.05.19v.88a.16.16,0,0,1-.05.14s-.06,0-.11,0l-.53-.32a.21.21,0,0,1-.11-.13.49.49,0,0,1-.05-.2v-.87a.2.2,0,0,1,.05-.14s.06,0,.11,0Z"
              />
              <path
                className={classes.cls_19}
                d="M402.76,149.31a.23.23,0,0,1,.11.14.45.45,0,0,1,.05.19v.87a.21.21,0,0,1-.05.15s-.06,0-.11,0l-.53-.31a.24.24,0,0,1-.11-.13.37.37,0,0,1-.05-.2v-.87a.16.16,0,0,1,.05-.14s.06,0,.11,0Z"
              />
              <path
                className={classes.cls_11}
                d="M389.28,146.3l26.36,15.22a1.22,1.22,0,0,1,.57.93c0,.34-.26.47-.57.29l-26.36-15.22a1.22,1.22,0,0,1-.57-.94C388.71,146.24,389,146.12,389.28,146.3Z"
              />
              <path
                className={classes.cls_2}
                d="M397.74,165.83l26.36,15.22a1.21,1.21,0,0,1,.56.94c0,.34-.25.46-.56.28l-26.36-15.22a1.19,1.19,0,0,1-.57-.93C397.17,165.78,397.42,165.65,397.74,165.83Z"
              />
              <path
                className={classes.cls_2}
                d="M397.74,175.6l12.61,7.29a1.19,1.19,0,0,1,.57.93c0,.34-.25.47-.57.29l-12.61-7.29a1.2,1.2,0,0,1-.57-.94C397.17,175.55,397.42,175.42,397.74,175.6Z"
              />
              <path
                className={classes.cls_11}
                d="M417.83,162.78l10.5,6a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-10.5-6a1.2,1.2,0,0,1-.57-.94C417.26,162.73,417.51,162.6,417.83,162.78Z"
              />
              <path
                className={classes.cls_11}
                d="M389.28,200l26.36,15.22a1.22,1.22,0,0,1,.57.94c0,.34-.26.46-.57.28l-26.36-15.22a1.22,1.22,0,0,1-.57-.93C388.71,200,389,199.83,389.28,200Z"
              />
              <path
                className={classes.cls_11}
                d="M417.83,216.49l10.5,6a1.19,1.19,0,0,1,.56.93c0,.34-.25.47-.56.29l-10.5-6a1.2,1.2,0,0,1-.57-.94C417.26,216.44,417.51,216.31,417.83,216.49Z"
              />
              <path
                className={classes.cls_11}
                d="M417.83,201.87l10.5,6a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-10.5-6a1.2,1.2,0,0,1-.57-.94C417.26,201.82,417.51,201.69,417.83,201.87Z"
              />
              <path
                className={classes.cls_11}
                d="M417.83,206.75l10.5,6a1.21,1.21,0,0,1,.56.94c0,.34-.25.46-.56.28l-10.5-6a1.19,1.19,0,0,1-.57-.93C417.26,206.7,417.51,206.57,417.83,206.75Z"
              />
              <path
                className={classes.cls_11}
                d="M408.87,196.68l5.9,3.41a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-5.9-3.41a1.18,1.18,0,0,1-.56-.93C408.31,196.63,408.56,196.5,408.87,196.68Z"
              />
              <path
                className={classes.cls_15}
                d="M389.28,151.19l15.37,8.87a1.2,1.2,0,0,1,.57.94c0,.34-.25.46-.57.28l-15.37-8.87a1.22,1.22,0,0,1-.57-.93C388.71,151.14,389,151,389.28,151.19Z"
              />
              <path
                className={classes.cls_20}
                d="M389.28,151.19l15.37,8.87a1.2,1.2,0,0,1,.57.94c0,.34-.25.46-.57.28l-15.37-8.87a1.22,1.22,0,0,1-.57-.93C388.71,151.14,389,151,389.28,151.19Z"
              />
              <path
                className={classes.cls_15}
                d="M389.28,156.07l5.21,3a1.2,1.2,0,0,1,.57.94c0,.34-.25.46-.57.28l-5.21-3a1.22,1.22,0,0,1-.57-.94C388.71,156,389,155.89,389.28,156.07Z"
              />
              <path
                className={classes.cls_20}
                d="M389.28,156.07l5.21,3a1.2,1.2,0,0,1,.57.94c0,.34-.25.46-.57.28l-5.21-3a1.22,1.22,0,0,1-.57-.94C388.71,156,389,155.89,389.28,156.07Z"
              />
              <path
                className={classes.cls_15}
                d="M389.28,161l5.21,3a1.19,1.19,0,0,1,.57.93c0,.34-.25.47-.57.29l-5.21-3a1.22,1.22,0,0,1-.57-.94C388.71,160.9,389,160.77,389.28,161Z"
              />
              <path
                className={classes.cls_20}
                d="M389.28,161l5.21,3a1.19,1.19,0,0,1,.57.93c0,.34-.25.47-.57.29l-5.21-3a1.22,1.22,0,0,1-.57-.94C388.71,160.9,389,160.77,389.28,161Z"
              />
              <path
                className={classes.cls_15}
                d="M389.28,165.83l5.21,3a1.2,1.2,0,0,1,.57.94c0,.33-.25.46-.57.28l-5.21-3a1.22,1.22,0,0,1-.57-.93C388.71,165.78,389,165.65,389.28,165.83Z"
              />
              <path
                className={classes.cls_20}
                d="M389.28,165.83l5.21,3a1.2,1.2,0,0,1,.57.94c0,.33-.25.46-.57.28l-5.21-3a1.22,1.22,0,0,1-.57-.93C388.71,165.78,389,165.65,389.28,165.83Z"
              />
              <path
                className={classes.cls_27}
                d="M397.74,170.71l15.37,8.88a1.22,1.22,0,0,1,.57.93c0,.34-.26.47-.57.29l-15.37-8.87a1.2,1.2,0,0,1-.57-.94C397.17,170.66,397.42,170.53,397.74,170.71Z"
              />
              <path
                className={classes.cls_27}
                d="M415.3,180.85l6.69,3.87a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-6.69-3.87a1.22,1.22,0,0,1-.57-.94C414.73,180.8,415,180.67,415.3,180.85Z"
              />
              <path
                className={classes.cls_20}
                d="M397.74,170.71l15.37,8.88a1.22,1.22,0,0,1,.57.93c0,.34-.26.47-.57.29l-15.37-8.87a1.2,1.2,0,0,1-.57-.94C397.17,170.66,397.42,170.53,397.74,170.71Z"
              />
              <path
                className={classes.cls_20}
                d="M415.3,180.85l6.69,3.87a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-6.69-3.87a1.22,1.22,0,0,1-.57-.94C414.73,180.8,415,180.67,415.3,180.85Z"
              />
              <path
                className={classes.cls_15}
                d="M389.28,170.72l5.21,3a1.2,1.2,0,0,1,.57.94c0,.34-.25.46-.57.29l-5.21-3a1.22,1.22,0,0,1-.57-.94C388.71,170.66,389,170.54,389.28,170.72Z"
              />
              <path
                className={classes.cls_20}
                d="M389.28,170.72l5.21,3a1.2,1.2,0,0,1,.57.94c0,.34-.25.46-.57.29l-5.21-3a1.22,1.22,0,0,1-.57-.94C388.71,170.66,389,170.54,389.28,170.72Z"
              />
              <path
                className={classes.cls_15}
                d="M406.84,161.32l6.69,3.88a1.21,1.21,0,0,1,.56.93c0,.34-.25.47-.56.29l-6.69-3.88a1.19,1.19,0,0,1-.56-.93C406.28,161.27,406.53,161.14,406.84,161.32Z"
              />
              <path
                className={classes.cls_20}
                d="M406.84,161.32l6.69,3.88a1.21,1.21,0,0,1,.56.93c0,.34-.25.47-.56.29l-6.69-3.88a1.19,1.19,0,0,1-.56-.93C406.28,161.27,406.53,161.14,406.84,161.32Z"
              />
              <path
                className={classes.cls_14}
                d="M404.08,184.14,419.46,193a1.21,1.21,0,0,1,.56.94c0,.33-.25.46-.56.28l-15.38-8.87a1.21,1.21,0,0,1-.56-.94C403.52,184.09,403.77,184,404.08,184.14Z"
              />
              <path
                className={classes.cls_14}
                d="M413,194.16,428.33,203a1.21,1.21,0,0,1,.56.94c0,.34-.25.47-.56.29L413,195.38a1.19,1.19,0,0,1-.56-.93C412.39,194.11,412.64,194,413,194.16Z"
              />
              <path
                className={classes.cls_14}
                d="M421.64,194.27l6.69,3.87a1.21,1.21,0,0,1,.56.94c0,.34-.25.46-.56.28l-6.69-3.87a1.21,1.21,0,0,1-.56-.93C421.08,194.22,421.33,194.09,421.64,194.27Z"
              />
              <path
                className={classes.cls_2}
                d="M421.64,213.61l6.69,3.88a1.19,1.19,0,0,1,.56.93c0,.34-.25.47-.56.29l-6.69-3.88a1.21,1.21,0,0,1-.56-.93C421.08,213.56,421.33,213.43,421.64,213.61Z"
              />
              <path
                className={classes.cls_15}
                d="M397.74,161l15.37,8.87a1.22,1.22,0,0,1,.57.94c0,.33-.26.46-.57.28l-15.37-8.87a1.2,1.2,0,0,1-.57-.94C397.17,160.9,397.42,160.77,397.74,161Z"
              />
              <path
                className={classes.cls_20}
                d="M397.74,161l15.37,8.87a1.22,1.22,0,0,1,.57.94c0,.33-.26.46-.57.28l-15.37-8.87a1.2,1.2,0,0,1-.57-.94C397.17,160.9,397.42,160.77,397.74,161Z"
              />
              <path
                className={classes.cls_15}
                d="M415.3,171.08,422,175a1.21,1.21,0,0,1,.56.94c0,.34-.25.47-.56.29l-6.69-3.88a1.22,1.22,0,0,1-.57-.93C414.73,171,415,170.9,415.3,171.08Z"
              />
              <path
                className={classes.cls_20}
                d="M415.3,171.08,422,175a1.21,1.21,0,0,1,.56.94c0,.34-.25.47-.56.29l-6.69-3.88a1.22,1.22,0,0,1-.57-.93C414.73,171,415,170.9,415.3,171.08Z"
              />
            </motion.g>
            <motion.g variants={code2Variants} animate="end" id="Mouse">
              <path
                className={classes.cls_9}
                d="M310.48,227l9.43,5.44a10.36,10.36,0,0,0,10.4-.55l15.54-11.35c2.78-2,2.62-5-.35-6.77l-4.73-2.73a12.81,12.81,0,0,0-10.92-.33l-19.19,10.4C307.59,222.68,307.51,225.32,310.48,227Z"
              />
              <path
                className={classes.cls_3}
                d="M346.11,215.64l-10.76,8.41-7.93,6.21a7.32,7.32,0,0,1-6.3-.19l-8.43-4.87h0l-.05,0a6,6,0,0,1-1.7-8.53c.08-.12.17-.23.25-.34A11.18,11.18,0,0,1,318,212l4.28-.86c6.91-1.4,12.59-2.09,13.25-1.64l10.57,6.13Z"
              />
              <path
                className={classes.cls_11}
                d="M340.1,220.34l.6-.47-9.48-5.48,8.3-2.57-.84-.48-8.3,2.57-5.66-3.27-1.07.21Z"
              />
              <path
                className={classes.cls_10}
                d="M328.35,229.75s0,0,0,0a0,0,0,0,1,0,0l7.55-5.45,10.2-7.37v-1.15a.09.09,0,0,0-.05-.09l-.06,0c-.76-.27-5.18,1.06-10.52,3.19l-3.54,1.4a10.91,10.91,0,0,0-3,1.79,11.25,11.25,0,0,0-4.09,8.68v.19a7,7,0,0,0,2.54-.61Z"
              />
            </motion.g>
          </g>
          <g id="Pot">
            <path
              className={classes.cls_11}
              d="M347.07,380.64c-10.38-10.71-16.48-54.29-6.36-62.78h51.51c10.12,8.49,4,52.05-6.34,62.77-.09.1-.2.19-.29.29l-.36.35c-.29.29-.6.57-.93.85l-.25.2c-.26.2-.51.4-.79.59a12.24,12.24,0,0,1-1.34.87c-8.53,5-22.37,5-30.91,0h0a14,14,0,0,1-1.35-.87c-.26-.18-.49-.37-.73-.56l-.31-.24c-.32-.27-.62-.54-.9-.82l-.42-.4C347.23,380.8,347.14,380.72,347.07,380.64Z"
            />
            <g className={classes.cls_17}>
              <path
                className={classes.cls_14}
                d="M347.07,380.64c-10.38-10.71-16.48-54.29-6.36-62.78h51.51c10.12,8.49,4,52.05-6.34,62.77-.09.1-.2.19-.29.29l-.36.35c-.29.29-.6.57-.93.85l-.25.2c-.26.2-.51.4-.79.59a12.24,12.24,0,0,1-1.34.87c-8.53,5-22.37,5-30.91,0h0a14,14,0,0,1-1.35-.87c-.26-.18-.49-.37-.73-.56l-.31-.24c-.32-.27-.62-.54-.9-.82l-.42-.4C347.23,380.8,347.14,380.72,347.07,380.64Z"
              />
            </g>
            <path
              className={classes.cls_28}
              d="M387.74,314.43c11.76,6.87,11.76,18,0,24.85s-30.8,6.86-42.55,0-11.75-18,0-24.84S376,307.57,387.74,314.43Z"
            />
            <g className={classes.cls_29}>
              <path
                className={classes.cls_14}
                d="M387.74,314.43c11.76,6.87,11.76,18,0,24.85s-30.8,6.86-42.55,0-11.75-18,0-24.84S376,307.57,387.74,314.43Z"
              />
            </g>
            <path
              className={classes.cls_5}
              d="M382.09,317.73c8.63,5,8.63,13.21,0,18.25s-22.62,5-31.25,0-8.63-13.21,0-18.25S373.46,312.7,382.09,317.73Z"
            />
            <g className={classes.cls_30}>
              <path d="M382.09,317.73c8.63,5,8.63,13.21,0,18.25s-22.62,5-31.25,0-8.63-13.21,0-18.25S373.46,312.7,382.09,317.73Z" />
            </g>
            <path
              className={classes.cls_1}
              d="M350.84,326.39c8.63-5,22.62-5,31.25,0a14.33,14.33,0,0,1,5.17,4.8,14.32,14.32,0,0,1-5.17,4.79c-8.63,5-22.62,5-31.25,0a14.4,14.4,0,0,1-5.17-4.79A14.42,14.42,0,0,1,350.84,326.39Z"
            />
            <g id="Plants">
              <motion.g variants={planet2Variants} animate="end">
                <path
                  className={classes.cls_31}
                  d="M362.25,304.4a14.44,14.44,0,0,1-1.32-3.76c-.57-3.13.21-6.73,2.75-8.66,1-.77,2.32-1.34,2.75-2.53a4.07,4.07,0,0,0,0-2.08c-.47-2.67-1.38-5.43-.63-8.05a9,9,0,0,1,5-5.35,27.13,27.13,0,0,1,7.28-1.9A11.61,11.61,0,0,0,382,271c1.44-.8,1.88-2.22,2.78-3.47a23.79,23.79,0,0,1,3.53-3.77c2.62-2.35,5.91-4.28,9.54-4.12,7.58.34,7.36,6.86,5.17,11.8s-2.76,6.55,2,11.7,4.75,11.49-.9,15-9.32,4-7.08,10.86c2,6.11,3.23,11.32-2.42,17.85-3.65,4.22-8.63,7.23-14.87,7a24.78,24.78,0,0,1-7.3-1.7c-1.72-.85-.56-2.19-1.14-3.88q-1.87-5.47-3.74-10.93a81,81,0,0,0-3-8.61C363.8,307.21,363,305.84,362.25,304.4Z"
                />
                <g className={classes.cls_32}>
                  <path d="M362.25,304.4a14.44,14.44,0,0,1-1.32-3.76c-.57-3.13.21-6.73,2.75-8.66,1-.77,2.32-1.34,2.75-2.53a4.07,4.07,0,0,0,0-2.08c-.47-2.67-1.38-5.43-.63-8.05a9,9,0,0,1,5-5.35,27.13,27.13,0,0,1,7.28-1.9A11.61,11.61,0,0,0,382,271c1.44-.8,1.88-2.22,2.78-3.47a23.79,23.79,0,0,1,3.53-3.77c2.62-2.35,5.91-4.28,9.54-4.12,7.58.34,7.36,6.86,5.17,11.8s-2.76,6.55,2,11.7,4.75,11.49-.9,15-9.32,4-7.08,10.86c2,6.11,3.23,11.32-2.42,17.85-3.65,4.22-8.63,7.23-14.87,7a24.78,24.78,0,0,1-7.3-1.7c-1.72-.85-.56-2.19-1.14-3.88q-1.87-5.47-3.74-10.93a81,81,0,0,0-3-8.61C363.8,307.21,363,305.84,362.25,304.4Z" />
                </g>
                <path
                  className={classes.cls_14}
                  d="M372.55,332.1a.57.57,0,0,0,.37-.54c-.32-37.41,20.3-59.75,20.51-60a.56.56,0,0,0,0-.79.55.55,0,0,0-.79,0c-.21.22-21.14,22.87-20.81,60.76a.56.56,0,0,0,.56.56Z"
                />
                <path
                  className={classes.cls_14}
                  d="M378.55,297.29l.11-.05c6.71-4.22,18.69-7.37,18.81-7.41a.56.56,0,0,0-.28-1.09c-.5.13-12.26,3.23-19.12,7.54a.58.58,0,0,0-.18.78A.55.55,0,0,0,378.55,297.29Z"
                />
                <path
                  className={classes.cls_14}
                  d="M380.62,292.16h0a.56.56,0,0,0,.31-.73A43.29,43.29,0,0,0,374.77,281a.56.56,0,0,0-.79-.07.57.57,0,0,0-.06.8,43,43,0,0,1,6,10.1A.56.56,0,0,0,380.62,292.16Z"
                />
              </motion.g>

              <motion.g variants={planet1Variants} animate="end">
                <path
                  className={classes.cls_11}
                  d="M367.29,336.15a31.51,31.51,0,0,1-16.43.61c-9.43-2-15.19-10.84-15.19-10.84s10.19-4.09,16.14-4.48a52.39,52.39,0,0,0-17.86.38s-5.45-2-4.42-11.25c0,0,5.14-3.78,17-2.3,0,0-5.93-4.23-16.31-5.48-.82,0,.29-12,1.28-17.34s3-4.53,7.2-4.06,16.8,3.32,18.4,6.4,0,10.93,0,10.93a18,18,0,0,0,3.47-10.28s4.73,1.73,7.25,4a16.78,16.78,0,0,1,4.52,5.66c-.59,4.22-2.57,10.64-5.35,14.23,0,0,6.26-4,7.7-11.49a26.08,26.08,0,0,1,4.95,14.65C379.59,324.87,375.4,331.86,367.29,336.15Z"
                />
                <path
                  className={classes.cls_33}
                  d="M367.29,336.15a31.51,31.51,0,0,1-16.43.61c-9.43-2-15.19-10.84-15.19-10.84s10.19-4.09,16.14-4.48a52.39,52.39,0,0,0-17.86.38s-5.45-2-4.42-11.25c0,0,5.14-3.78,17-2.3,0,0-5.93-4.23-16.31-5.48-.82,0,.29-12,1.28-17.34s3-4.53,7.2-4.06,16.8,3.32,18.4,6.4,0,10.93,0,10.93a18,18,0,0,0,3.47-10.28s4.73,1.73,7.25,4a16.78,16.78,0,0,1,4.52,5.66c-.59,4.22-2.57,10.64-5.35,14.23,0,0,6.26-4,7.7-11.49a26.08,26.08,0,0,1,4.95,14.65C379.59,324.87,375.4,331.86,367.29,336.15Z"
                />
                <path
                  className={classes.cls_14}
                  d="M368.53,335.31a.54.54,0,0,1-.34-.46C366.77,317,346.79,289.1,338,283.5a.54.54,0,0,1-.17-.74.53.53,0,0,1,.74-.17c9,5.69,29.28,34,30.73,52.18a.54.54,0,0,1-.49.58A.51.51,0,0,1,368.53,335.31Z"
                />
              </motion.g>
            </g>
          </g>
          <g id="Character">
            <path
              className={classes.cls_34}
              d="M187.86,324.15c0-.2-3.21-11.79-3.21-11.79s1,1.06,7.75-.7a38,38,0,0,0,7.29-3.06l1.91,8.47c1.79,3.26,7.71,1.76,14.19,1,1.09-.12,2.21-.3,3.33-.5h.07c3.5-.2,7,1.91,3.37,4.89s-9.64,4.12-15.18,5.12C200.73,328.8,189.05,330.76,187.86,324.15Z"
            />
            <path
              className={classes.cls_10}
              d="M234.41,323.12a6.84,6.84,0,0,1,.48,3.57c-.13,1.29-3.32,5.67-9,8.35s-12.62,2.86-15.89,3.8-6.26,2.82-10.11,3.76-7.65,1.43-11.51-1.11c-.71-1.1-1.5-3.63-1.27-3.87C187.76,337,234.41,323.12,234.41,323.12Z"
            />
            <path
              className={classes.cls_19}
              d="M202.62,318.2c2.48,1.72,7.62.53,13.17-.11,5.23-.59,11.13-2.43,14.68-1.2s6.54,5.42,1.73,10.79c-1.39,1.56-4.34,4.29-6.69,5.13-6,2.14-11.34,2.31-15.18,3.26-5,1.24-7.74,3.45-12.37,4-6,.69-9.77-.84-10.81-2.44s-2-14.49.57-14.23c0,0,1.08,4.17,10.86.12C202.85,321.74,202.78,319.14,202.62,318.2Z"
            />
            <path
              className={classes.cls_35}
              d="M202.62,318.2c2.48,1.72,7.62.53,13.17-.11,5.23-.59,11.13-2.43,14.68-1.2s6.54,5.42,1.73,10.79c-1.39,1.56-4.34,4.29-6.69,5.13-6,2.14-11.34,2.31-15.18,3.26-5,1.24-7.74,3.45-12.37,4-6,.69-9.77-.84-10.81-2.44s-2-14.49.57-14.23c0,0,1.08,4.17,10.86.12C202.85,321.74,202.78,319.14,202.62,318.2Z"
            />
            <path
              className={classes.cls_36}
              d="M219.22,325.12s-.56-5.45-4.59-6.89a2.11,2.11,0,0,0-2.21.29s3.73.55,5,6.93c0,0,.2.42,1,.28C218.65,325.68,219.26,325.57,219.22,325.12Z"
            />
            <path
              className={classes.cls_36}
              d="M209,319s0-.18.94-.36a1.66,1.66,0,0,1,1.1.12s3,1.3,3.57,7a1,1,0,0,1-.93.88.82.82,0,0,1-1.07-.56S212,320,209,319Z"
            />
            <path
              className={classes.cls_36}
              d="M205.77,319.07s.16-.35.87-.34c.89,0,1.1.35,1.1.35s2.13,2.19,2.16,6.94c0,0,.09.81-1,.89s-1-.83-1-.83S207.52,320,205.77,319.07Z"
            />
            <path
              className={classes.cls_3}
              d="M183.72,245.32c4.9,14.73,17.9,65.46,17.9,65.46s-8.46,7.6-17.64,4.14l-21.87-63.17Z"
            />
            <path
              className={classes.cls_34}
              d="M221.51,340.53c-1-1.49-4.76-11.81-4.76-11.81s3.92,2.25,10.67.64c3.43-.81,6.63-4.54,6.63-4.54l2.88,9.92c1.71,3.3,7.21,2.21,13.71,1.63,1.1-.1,2.22-.25,3.35-.42h.06c3.51-.11,7,2.08,3.26,5s-9.75,3.87-15.3,4.74C235.32,346.71,225.25,346.09,221.51,340.53Z"
            />
            <path
              className={classes.cls_10}
              d="M271.93,340.22a7.23,7.23,0,0,1,.42,3.83c-.17,1.39-3.71,6-9.84,8.74s-13.62,2.74-17.15,3.66-6.8,2.86-11,3.76-8.26,1.34-12.34-1.49c-.73-1.2-1.51-3.93-1.26-4.19C221.49,353.83,271.93,340.22,271.93,340.22Z"
            />
            <path
              className={classes.cls_19}
              d="M238,334c.41.27.81.54,1.23.76a3.77,3.77,0,0,0,1.37.28,19.85,19.85,0,0,0,3.27.08c2.75-.14,5.48-.55,8.21-.8,5.64-.5,12-2.32,15.8-.9s7.24,6,1.94,11.61c-1.53,1.63-4.69,4.39-7.11,5.4-6.29,2.63-12.81,2.13-17,3.05-5.4,1.2-8.39,3.5-13.37,4-6.45.58-10.48-1.17-11.55-2.91-.59-1,.07-6-.74-10-.69-3.38-.51-5.68.7-5.52a6.37,6.37,0,0,0,.95,1.19,4.37,4.37,0,0,0,1.43,1.13,11.23,11.23,0,0,0,2.41.82,14.07,14.07,0,0,0,4.49.61,2.13,2.13,0,0,0,1.22-.38,2.54,2.54,0,0,0,.71-1.53c.11-.5.22-1,.32-1.49a2.33,2.33,0,0,1,.27-.78,2.2,2.2,0,0,1,.77-.61,6.42,6.42,0,0,0,2.45-1.87,5.63,5.63,0,0,0,.72-2.31.64.64,0,0,1,.17-.38c.18-.15.45,0,.65.1Z"
            />
            <path
              className={classes.cls_35}
              d="M238,334c.41.27.81.54,1.23.76a3.77,3.77,0,0,0,1.37.28,19.85,19.85,0,0,0,3.27.08c2.75-.14,5.48-.55,8.21-.8,5.64-.5,12-2.32,15.8-.9s7.24,6,1.94,11.61c-1.53,1.63-4.69,4.39-7.11,5.4-6.29,2.63-12.81,2.13-17,3.05-5.4,1.2-8.39,3.5-13.37,4-6.45.58-10.48-1.17-11.55-2.91-.59-1,.07-6-.74-10-.69-3.38-.51-5.68.7-5.52a6.37,6.37,0,0,0,.95,1.19,4.37,4.37,0,0,0,1.43,1.13,11.23,11.23,0,0,0,2.41.82,14.07,14.07,0,0,0,4.49.61,2.13,2.13,0,0,0,1.22-.38,2.54,2.54,0,0,0,.71-1.53c.11-.5.22-1,.32-1.49a2.33,2.33,0,0,1,.27-.78,2.2,2.2,0,0,1,.77-.61,6.42,6.42,0,0,0,2.45-1.87,5.63,5.63,0,0,0,.72-2.31.64.64,0,0,1,.17-.38c.18-.15.45,0,.65.1Z"
            />
            <path
              className={classes.cls_36}
              d="M255.57,342s-.46-5.86-4.74-7.52a2.27,2.27,0,0,0-2.39.26s4,.68,5.14,7.57c0,0,.2.45,1.07.32C255,342.54,255.6,342.44,255.57,342Z"
            />
            <path
              className={classes.cls_36}
              d="M244.75,335.06s0-.19,1-.36a1.78,1.78,0,0,1,1.18.16s3.19,1.48,3.64,7.6a1.09,1.09,0,0,1-1,.92.89.89,0,0,1-1.14-.63S247.93,336.31,244.75,335.06Z"
            />
            <path
              className={classes.cls_36}
              d="M241.29,335.1s.19-.36.94-.34c1,0,1.17.41,1.17.41s2.24,2.4,2.14,7.51c0,0,.07.87-1.13.93s-1-.92-1-.92S243.14,336.18,241.29,335.1Z"
            />
            <path
              className={classes.cls_4}
              d="M218.21,262.71c3.86,11.88,13.71,45.67,18.22,63.05,0,0-8.1,7.27-18.5,6.64l-25.09-65.07,10-6.18Z"
            />
            <path
              className={classes.cls_4}
              d="M135.6,425.15a1.62,1.62,0,0,0,1.62-1.63V318.93a1.63,1.63,0,0,0-3.25,0V423.52A1.63,1.63,0,0,0,135.6,425.15Z"
            />
            <path
              className={classes.cls_4}
              d="M70.89,387.08a1.64,1.64,0,0,0,1.51-1l32.07-81.17a1.63,1.63,0,0,0-3-1.2L69.37,384.86a1.63,1.63,0,0,0,.92,2.11A1.56,1.56,0,0,0,70.89,387.08Z"
            />
            <path
              className={classes.cls_4}
              d="M74.74,377.33a1.61,1.61,0,0,0,1.18-.51l59.68-63.15,59.57,62.89a1.63,1.63,0,0,0,2.36-2.24l-60.75-64.13a1.62,1.62,0,0,0-1.18-.51h0a1.62,1.62,0,0,0-1.18.51l-60.85,64.4a1.63,1.63,0,0,0,.06,2.3A1.67,1.67,0,0,0,74.74,377.33Z"
            />
            <path
              className={classes.cls_4}
              d="M200.31,387.08a1.54,1.54,0,0,0,.59-.11,1.63,1.63,0,0,0,.92-2.11l-32.07-81.18a1.63,1.63,0,0,0-3,1.2l32.07,81.17A1.64,1.64,0,0,0,200.31,387.08Z"
            />
            <path
              className={classes.cls_5}
              d="M201.09,283.07c1.17-6.56-4.18-11.68-14.23-18.47a237.85,237.85,0,0,0-29.14-16.37c-8.41-3.86-17-3.51-27.79,2-15,7.69-60,35-60,35s67.32,38,80.27,36.3,45.33-22.75,47.9-30.16S201.09,283.07,201.09,283.07Z"
            />
            <g className={classes.cls_37}>
              <path d="M201.09,283.07c1.17-6.56-4.18-11.68-14.23-18.47a237.85,237.85,0,0,0-29.14-16.37c-8.41-3.86-17-3.51-27.79,2-15,7.69-60,35-60,35s67.32,38,80.27,36.3,45.33-22.75,47.9-30.16S201.09,283.07,201.09,283.07Z" />
            </g>
            <path
              className={classes.cls_5}
              d="M143.71,313.56c9.67,8.75,19.77,1.22,35.75-9.15,18.08-11.74,21.63-21.34,21.63-21.34s0,7.19-1.35,10.57-4.27,7.19-17.31,16.19S159.94,323.32,151.17,325l-6.92-1"
            />
            <path
              className={classes.cls_7}
              d="M179.46,304.41c18.08-11.74,21.63-21.34,21.63-21.34s0,7.19-1.35,10.57-4.27,7.19-17.31,16.19S159.94,323.32,151.17,325l-6.92-1-.54-10.47C153.38,322.31,163.48,314.78,179.46,304.41Z"
            />
            <path
              className={classes.cls_19}
              d="M73.41,374.34l-5,11.43a.93.93,0,0,0,0,.29,1.48,1.48,0,0,0,0,.21A1.38,1.38,0,0,0,69,387a3,3,0,0,0,2.68.12,1.16,1.16,0,0,0,.55-.52v0l0-.16,4.6-10.71Z"
            />
            <path
              className={classes.cls_19}
              d="M198.09,374.82,202.34,386a1.43,1.43,0,0,1,0,.29.67.67,0,0,1,0,.2,1.28,1.28,0,0,1-.64.71,2.86,2.86,0,0,1-2.58,0,1.14,1.14,0,0,1-.5-.53v0l0-.15L194.68,376Z"
            />
            <path
              className={classes.cls_19}
              d="M133.72,415.43v9.25a.93.93,0,0,0,.55.77,2.94,2.94,0,0,0,2.65,0,.93.93,0,0,0,.55-.77v-9.25A4,4,0,0,0,133.72,415.43Z"
            />
            <path
              className={classes.cls_3}
              d="M96.9,243.85c3.84,4.46,38.73-5.57,48-6.83,14.91-2,27-3.52,32.11-1.93s7.2,4.17,8.76,10.23c1.82,7.15,2.77,10.79,2.77,10.79s-24.77,9.51-44.3,11.8S96.9,243.85,96.9,243.85Z"
            />
            <path
              className={classes.cls_4}
              d="M90.4,250.4c-3.87,14.73-7.35,31.87,1.6,41.26,6,6.32,36.32,22.74,55.85,16.27C167.1,301.56,207,272,211,269s7.64-5,7.26-6.28c-5.38-17.84-13.23-19.23-27.8-16-17.81,3.92-56.92,19.88-56.92,19.88Z"
            />
            <polygon
              className={classes.cls_34}
              points="178.89 155.64 165.45 170.84 143.75 160.54 158.92 139.55 178.89 155.64"
            />
            <path
              className={classes.cls_38}
              d="M195.56,126.78s5.5,7.95,4.91,8.76-4.48,1.61-4.48,1.61Z"
            />
            <circle
              className={classes.cls_39}
              cx="195.51"
              cy="125.45"
              r="5.98"
            />
            <path
              className={classes.cls_34}
              d="M180.28,104.81c10.81,2,14,6.68,15.43,23.74,1.47,17.84-.22,23.49-2.51,25.95-1.55,1.66-10.34,2.15-14.81,1-5.59-1.4-18.25-5.57-24.34-14.41-7.16-10.41-9.3-24.69-2-30.74C162.25,101.87,175.89,104,180.28,104.81Z"
            />
            <path
              className={classes.cls_38}
              d="M178.89,155.64c4.65,1.06,11.72.42,13.82-.79a15.75,15.75,0,0,1-7.82-.28,25.61,25.61,0,0,1-7.17-3.16Z"
            />
            <path
              className={classes.cls_10}
              d="M197.72,111.79l0,0c-3,2.08-6.69,3-10.32,3.51.29,2.9-.62,5.76-1.52,8.53-.62,1.91-2.87,7.92-5.32,4.62-1.77-2.38-3.38-4.55-6.76-4-5.58,1-6.18,8.12-2.55,12.38s6.88,2.51,6.88,2.51.52,7.7-3.54,13.13c0,0-6.06,3.72-14.55.92-5.37-1.76-13.11-8.53-16-13.8-7.85-14.53-7.89-28.44,1.63-32.72.88-7,6.27-10.2,12.47-11.78,8.59-2.18,17.51,3.21,25.81-.34,1.75-.75,3.36-1.82,5.15-2.46a3.49,3.49,0,0,1,3.09,0,3.73,3.73,0,0,1,1.32,2.36,6.67,6.67,0,0,1-.33,5,14.22,14.22,0,0,1,3.9-1.44,4.89,4.89,0,0,1,3.95.89,5,5,0,0,1,1.58,3.44C203,106.19,200.72,109.71,197.72,111.79Z"
            />
            <path
              className={classes.cls_10}
              d="M145.56,109.24,139,105.59a3.74,3.74,0,0,1,6.53,3.65Z"
            />
            <line
              className={classes.cls_40}
              x1="180.52"
              y1="128.47"
              x2="201.42"
              y2="124.56"
            />
            <path
              className={classes.cls_34}
              d="M224.23,164.52c-.57-.94-1.82-1.12-2.85-1.48-1.92-.67-3.42-2.21-5.27-3a10.27,10.27,0,0,0-6.66-.45,15.5,15.5,0,0,0-2.22.71,29.68,29.68,0,0,0-4,2c-5.29,3.14-9.27,10.22-14.48,13.47-1.94,1.22-3.75,2.32-5.54,3.41l12.44,11.09a74.76,74.76,0,0,1,6.13-4.67c3.06-1.82,6.15-1.86,9.59-2.36a47.43,47.43,0,0,0,7-1.76,3,3,0,0,0,2.06-1.35,2.07,2.07,0,0,0-1.33-2.56,18.14,18.14,0,0,0-3.64-.49c-.89-.15-3.29.39-3.82-.52-.28-.47.06-1.06.41-1.49,2.15-2.68,4.88-5.57,8.33-6.38a7.17,7.17,0,0,0,3-1.2A2.41,2.41,0,0,0,224.23,164.52Z"
            />
            <path
              className={classes.cls_19}
              d="M149.83,152.12c-13.21-7.21-25.23-2.58-29.57,6.69-3.92,8.39-12.16,40.84-12.16,40.84C112.06,207.08,149.83,152.12,149.83,152.12Z"
            />
            <path
              className={classes.cls_15}
              d="M147.85,154.72l2-2.6c-14.91-7.09-28.26,2.22-40,20.51-12.68,19.72-19.33,48-19.4,77.91,0,0,2.53,13.43,19.5,20.15,18,7.12,43.11,4.11,50.93-14.55,0,0,.16-18.64,5.83-27.81,3.67-5.94,12.22-19.14,18.58-28.6,5.54-8.24,9.84-27-1.73-33.85a95.7,95.7,0,0,0-9.4-4.8C163.59,164.55,146.5,158.9,147.85,154.72Z"
            />
            <path
              className={classes.cls_41}
              d="M147.9,154.79l1.93-2.67c-14.91-7.09-28.26,2.22-40,20.51-12.68,19.72-19.33,48-19.4,77.91,0,0,2.53,13.43,19.5,20.15,18,7.12,43.11,4.11,50.93-14.55,0,0,.16-18.64,5.83-27.81,3.67-5.94,12.22-19.14,18.58-28.6,5.54-8.24,9.84-27-1.73-33.85a95.7,95.7,0,0,0-9.4-4.8C163.59,164.55,146.54,159,147.9,154.79Z"
            />
            <path
              className={classes.cls_42}
              d="M190.07,187.78a30.2,30.2,0,0,0,.46-10.86h0a58.5,58.5,0,0,1-11.26,17.2c-6.07,6.39-13.57,11.37-19.2,18.15-6,7.18-10.25,15.86-15.24,23.71-2,3.15-4.74,9.22-8.46,9.46-4.54.3-8.88-5.24-11.36-9.05-4-6.09-7.34-13.69-12.25-19-4.29-4.67-10.92-10.65-16.77-7.94h0q-.64,2.33-1.23,4.71c-.39,1.6-.76,3.21-1.09,4.83a1.16,1.16,0,0,0,0,.18c-.34,1.63-.65,3.25-.93,4.89,0,.08,0,.17,0,.26-.28,1.61-.53,3.24-.75,4.86a159.12,159.12,0,0,0-1.5,21.4s2.53,13.43,19.5,20.15c18,7.12,43.11,4.11,50.93-14.55,0,0,.16-18.64,5.83-27.81.57-.93,1.27-2,2.05-3.27h0l.14-.21c.64-1,1.35-2.13,2.1-3.31a1.64,1.64,0,0,0,.14-.22l.06-.09c1.62-2.52,3.43-5.33,5.31-8.21.29-.44.57-.88.86-1.31,1.81-2.78,3.66-5.59,5.43-8.24l0,0c.59-.9,1.17-1.76,1.74-2.62l.73-1.08h0c.2-.3.39-.61.59-.94a2.75,2.75,0,0,0,.17-.29c.15-.25.29-.49.42-.75s.13-.22.19-.33c.15-.29.3-.58.44-.88l.12-.23c.18-.39.37-.8.55-1.21l0-.05,0-.07c.16-.37.31-.75.46-1.14,0-.09.07-.18.11-.28.14-.36.27-.73.41-1.11l0-.09a.56.56,0,0,1,0-.12c.24-.7.46-1.41.66-2.14h0c.2-.73.39-1.47.55-2.22v0Z"
            />
            <path
              className={classes.cls_34}
              d="M259.26,205.93a29.26,29.26,0,0,1-3.1,3.2c-4.56,4.13-9.9,6.11-16.09,10.14-5,3.25-12.73,8-19.24,12a97.38,97.38,0,0,1-21,9.69c-6,1.77-9.44,1.85-13-7.84-1.76-4.75-3.15-9.62-4.66-14.46q-3.37-10.78-6.64-21.61s-8-19.83,10-29.78c7.83,4.48,10.81,6.29,13.27,15.67,2.93,11.22,7.69,33.38,7.69,33.38a158.5,158.5,0,0,0,18.6-7.91c2.28-1.14,5.09-1.93,6.72-4a32.4,32.4,0,0,0,2.86-4.45c.76-1.38,1.32-2.89,2.16-4.21a37.67,37.67,0,0,1,5.92-6.51,2.45,2.45,0,0,1,1.43-.85,1.65,1.65,0,0,1,1.45.89c.66,1.15,0,2.29-.3,3.47-.38,1.34-.77,2.69-1.15,4a35.22,35.22,0,0,0,11.47-10.76,5.62,5.62,0,0,1,.91-1.15,1.76,1.76,0,0,1,1.33-.49c1.21.15,2.4,2.1,2.46,3.21a17.29,17.29,0,0,0,.09,3.38c.27,1.05,1,1.91,1.3,2.93a16.26,16.26,0,0,1,.69,3.24,11.13,11.13,0,0,1-1.83,6.78A14.92,14.92,0,0,1,259.26,205.93Z"
            />
            <path
              className={classes.cls_19}
              d="M184.44,166.47c6.86,2.78,11.8,5.91,14.92,16.37s6.52,27.24,6.52,27.24.06,3.51-8.26,8.41a20.48,20.48,0,0,1-16.11,2.17l-6.28-20.19S164.08,173.45,184.44,166.47Z"
            />
            <path
              className={classes.cls_19}
              d="M144.25,324c-5.51-.27-9.81-4.31-22.9-9.77-24.16-10.06-42.28-18.12-49.18-30.77s-11.79-49.18-10.07-65a20.84,20.84,0,0,1,1.19-5.25l-1.7-.25,4.4-3.74h0c4.51-3.69,11.86-.4,17.4,2.61,15.81,8.61,28.18,17,38,47.17,7.36,22.72,12.21,43.44,22.36,54.52"
            />
            <path
              className={classes.cls_43}
              d="M63.29,213.24l-1.7-.25,4.4-3.74h0c4.51-3.69,11.86-.4,17.4,2.61,15.81,8.61,28.18,17,38,47.17,7.36,22.72,12.21,43.44,22.36,54.52l.54,10.47c-5.51-.27-9.81-4.31-22.9-9.77-24.16-10.06-42.28-18.12-49.18-30.77s-11.79-49.18-10.07-65A20.84,20.84,0,0,1,63.29,213.24Z"
            />
            <path
              className={classes.cls_11}
              d="M78.8,215.76c15.82,8.61,28.19,17,38,47.17s15.13,56.88,34.4,62.06c0,0-8.72,3.46-35.42-7.83-8.49-3.59-18.8-10.15-25.58-14-13.27-7.45-21.31-13.55-22.58-15.83-7-12.6-11.8-49.18-10.07-65S70.88,211.45,78.8,215.76Z"
            />
          </g>
          <motion.g
            variants={codeVariants}
            animate="end"
            id="Speech_Bubble"
            data-name="Speech Bubble"
          >
            <path
              className={classes.cls_19}
              d="M167.7,81.82l-4.36-8.22,3.51-10.14V57.25l-10.76,6.21v6.21l4.63,8A.75.75,0,0,0,161,78h0Z"
            />
            <path
              className={classes.cls_44}
              d="M167.7,81.82l-4.36-8.22,3.51-10.14V57.25l-10.76,6.21v6.21l4.63,8A.75.75,0,0,0,161,78h0Z"
            />
            <path
              className={classes.cls_11}
              d="M193.39,7.87a7.13,7.13,0,0,0-3.22-5.58L187.54.77a7.12,7.12,0,0,0-6.45,0L140.82,24.06a7.14,7.14,0,0,0-3.23,5.59V74a7.14,7.14,0,0,0,3.23,5.59l2.63,1.51a7.12,7.12,0,0,0,6.45,0l12.95-7.48,4.61,8a.69.69,0,0,0,1.25-.12l4.88-14.08,16.58-9.61a7.13,7.13,0,0,0,3.22-5.58Z"
            />
            <path
              className={classes.cls_44}
              d="M137.59,74a7.14,7.14,0,0,0,3.23,5.59l2.63,1.51a7.19,7.19,0,0,0,5.89.26c-1.51.58-2.67-.28-2.67-2.12V34.89a6.53,6.53,0,0,1,1-3.18l-9.08-5.24a6.64,6.64,0,0,0-.95,3.18Z"
            />
            <path
              className={classes.cls_16}
              d="M193.29,7c-.38-1.37-1.63-1.81-3.12-1l-40.28,23.3a6.38,6.38,0,0,0-2.27,2.41l-9.07-5.24a6.53,6.53,0,0,1,2.27-2.41L181.09.77a7.18,7.18,0,0,1,6.45,0l2.63,1.52A7.15,7.15,0,0,1,193.29,7Z"
            />
            <g id="_" data-name="&lt;/&gt;">
              <path
                className={classes.cls_14}
                d="M152.59,52.29a2.29,2.29,0,0,1,.17-.92,5.88,5.88,0,0,1,.47-.86L162,36.35a1.23,1.23,0,0,1,.15-.16.32.32,0,0,1,.09-.08c.14-.07.24-.07.33,0a.55.55,0,0,1,.13.43V42a2.37,2.37,0,0,1-.25,1.14c-.17.31-.32.55-.45.74l-4.51,6.89L162,52.86a1.84,1.84,0,0,1,.45.22c.17.1.25.38.25.83v3.88a1.33,1.33,0,0,1-.13.58.86.86,0,0,1-.33.39l-.09,0a.38.38,0,0,1-.15,0l-8.75-4a1.2,1.2,0,0,1-.47-.31,1.16,1.16,0,0,1-.17-.73Z"
              />
              <path
                className={classes.cls_14}
                d="M171.68,30.42a4.13,4.13,0,0,1,.33-.88,1.59,1.59,0,0,1,.63-.68l2.94-1.7a.27.27,0,0,1,.34,0,.59.59,0,0,1,.14.44A1.48,1.48,0,0,1,176,28l-7.4,31.54a3.49,3.49,0,0,1-.3.85,1.64,1.64,0,0,1-.66.72l-2.87,1.65a.24.24,0,0,1-.33,0,.57.57,0,0,1-.15-.44,1.56,1.56,0,0,1,0-.33Z"
              />
              <path
                className={classes.cls_14}
                d="M187.77,35.52a2.49,2.49,0,0,1-.16.92,6.58,6.58,0,0,1-.48.87l-8.75,14.15-.14.17-.1.07a.25.25,0,0,1-.33,0,.58.58,0,0,1-.13-.43V45.8a2.24,2.24,0,0,1,.25-1.12,8.38,8.38,0,0,1,.45-.73L182.21,38l-3.83-1.46a1.92,1.92,0,0,1-.45-.23c-.17-.12-.25-.4-.25-.85V30a1.29,1.29,0,0,1,.13-.58.9.9,0,0,1,.33-.4l.1,0h.14l8.75,4a1.22,1.22,0,0,1,.48.32,1.24,1.24,0,0,1,.16.73Z"
              />
            </g>
          </motion.g>

          <g id="Text_Box-2" data-name="Text Box">
            <g id="_3" data-name="{}">
              <g id="Speech_Bubble-3" data-name="Speech Bubble">
                <g id="Speach_Bubble-2" data-name="Speach Bubble">
                  <path
                    className={classes.cls_10}
                    d="M70.55.64,16.94,32.17a2.94,2.94,0,0,0-1.31,2.33l.27,30.08a2.93,2.93,0,0,0,1.37,2.29l5.34,3a3,3,0,0,0,2.68,0L78.9,38.27A3,3,0,0,0,80.22,36L79.94,5.87a2.92,2.92,0,0,0-1.36-2.29L73.23.6A3,3,0,0,0,70.55.64Z"
                  />
                  <path
                    className={classes.cls_4}
                    d="M79.92,5.62c-.11-.67-.66-.9-1.32-.52L25,36.64a2.71,2.71,0,0,0-.94,1l-8-4.52a2.58,2.58,0,0,1,.92-1L70.55.63a3,3,0,0,1,2.68,0l5.35,3A3,3,0,0,1,79.92,5.62Z"
                  />
                  <path
                    className={classes.cls_3}
                    d="M78.6,5.11,25,36.64A2.94,2.94,0,0,0,23.68,39L24,69c0,.86.61,1.2,1.34.76L78.9,38.27A3,3,0,0,0,80.22,36L79.94,5.87C79.93,5,79.33,4.67,78.6,5.11Z"
                  />
                </g>
              </g>
            </g>
            <path
              className={classes.cls_45}
              d="M37.24,37a.24.24,0,0,1,.32,0,.57.57,0,0,1,.14.42l.16,17.12a1.36,1.36,0,0,1-.13.58.8.8,0,0,1-.33.4l-2.24,1.33a.27.27,0,0,1-.33,0,.58.58,0,0,1-.14-.43L34.63,50l-3.8,2.24.06,6.49a1.4,1.4,0,0,1-.13.59.9.9,0,0,1-.32.4L28.19,61a.24.24,0,0,1-.32,0,.58.58,0,0,1-.14-.44l-.16-17.11a1.4,1.4,0,0,1,.13-.59.85.85,0,0,1,.33-.4l2.24-1.32a.25.25,0,0,1,.33,0,.57.57,0,0,1,.14.42L30.8,48l3.79-2.24-.05-6.39a1.22,1.22,0,0,1,.13-.58.93.93,0,0,1,.32-.41Z"
            />
            <path
              className={classes.cls_45}
              d="M49.75,29.66a.25.25,0,0,1,.32,0,.59.59,0,0,1,.15.43l0,2.81a1.39,1.39,0,0,1-.13.58.84.84,0,0,1-.32.4l-3,1.78.13,13.59a1.37,1.37,0,0,1-.14.58.87.87,0,0,1-.32.41L44.2,51.58a.25.25,0,0,1-.33,0,.57.57,0,0,1-.14-.42l-.12-13.59-3,1.77a.23.23,0,0,1-.32,0,.53.53,0,0,1-.14-.42l0-2.81a1.36,1.36,0,0,1,.13-.58.88.88,0,0,1,.33-.41Z"
            />
            <path
              className={classes.cls_45}
              d="M57.74,38.9a1.58,1.58,0,0,1-.24-.3l-1.65-3.43.08,8.77a1.26,1.26,0,0,1-.13.59.9.9,0,0,1-.32.4l-2.24,1.32a.24.24,0,0,1-.33,0,.57.57,0,0,1-.14-.42L52.61,28.7a1.4,1.4,0,0,1,.13-.59.85.85,0,0,1,.33-.4l2-1.17c.23-.14.4-.14.52,0a1.4,1.4,0,0,1,.23.29l2.83,5.7,2.71-9c0-.11.11-.29.22-.56a1.19,1.19,0,0,1,.51-.59l2-1.17a.24.24,0,0,1,.32,0,.58.58,0,0,1,.15.42l.15,17.12a1.39,1.39,0,0,1-.13.58.8.8,0,0,1-.33.4L62,41.1a.25.25,0,0,1-.32,0,.59.59,0,0,1-.15-.43l-.08-8.77L59.86,37.2a4.79,4.79,0,0,1-.22.58,1.07,1.07,0,0,1-.4.46l-1.1.64C58,39,57.84,39,57.74,38.9Z"
            />
            <path
              className={classes.cls_45}
              d="M76.29,28.4a.24.24,0,0,1,.32,0,.58.58,0,0,1,.15.42l0,2.81a1.4,1.4,0,0,1-.13.59.9.9,0,0,1-.32.4L68.4,37.31a.25.25,0,0,1-.33,0,.57.57,0,0,1-.14-.42l-.15-17.11a1.4,1.4,0,0,1,.13-.59.9.9,0,0,1,.32-.4l2.25-1.32a.23.23,0,0,1,.32,0,.51.51,0,0,1,.14.42l.13,13.59Z"
            />
          </g>
          <g id="Text_Box" data-name="Text Box">
            <g id="_2" data-name="{}">
              <g id="Speech_Bubble-2" data-name="Speech Bubble">
                <g id="Speach_Bubble" data-name="Speach Bubble">
                  <path
                    className={classes.cls_10}
                    d="M70.86,65.33,17,96.37a3,3,0,0,0-1.33,2.32v30.08a2.92,2.92,0,0,0,1.34,2.3l5.32,3a3,3,0,0,0,2.68,0l53.89-31a3,3,0,0,0,1.34-2.32V70.64a2.9,2.9,0,0,0-1.35-2.3l-5.32-3A3,3,0,0,0,70.86,65.33Z"
                  />
                  <path
                    className={classes.cls_4}
                    d="M80.19,70.4c-.11-.67-.66-.91-1.32-.53L25,100.92a2.67,2.67,0,0,0-.94,1l-8-4.6a2.82,2.82,0,0,1,.93-.95l53.88-31a3,3,0,0,1,2.69,0l5.31,3A2.94,2.94,0,0,1,80.19,70.4Z"
                  />
                  <path
                    className={classes.cls_3}
                    d="M78.87,69.87,25,100.92a2.94,2.94,0,0,0-1.34,2.31v30.08c0,.85.6,1.2,1.34.77l53.89-31a3,3,0,0,0,1.34-2.32V70.64C80.21,69.79,79.61,69.45,78.87,69.87Z"
                  />
                </g>
              </g>
            </g>
            <path
              className={classes.cls_45}
              d="M37,108.63c0,.23,0,.56,0,1s0,.84,0,1.27,0,.85,0,1.27,0,.72,0,1a5.6,5.6,0,0,0,.16,1.07,1.64,1.64,0,0,0,.37.76.91.91,0,0,0,.66.3,1.86,1.86,0,0,0,1-.31,3.77,3.77,0,0,0,1-.77,4.68,4.68,0,0,0,.62-.87,4.43,4.43,0,0,0,.37-.89c.09-.3.15-.57.2-.81a3.33,3.33,0,0,1,.19-.7.86.86,0,0,1,.4-.4l2.25-1.3a.21.21,0,0,1,.27,0,.51.51,0,0,1,.11.35,10.63,10.63,0,0,1-.43,2.79A13,13,0,0,1,42.93,115a12.25,12.25,0,0,1-1.69,2.37,8.77,8.77,0,0,1-2.11,1.74,4.47,4.47,0,0,1-2.21.7,2.48,2.48,0,0,1-1.66-.59,3.72,3.72,0,0,1-1.06-1.68,8.62,8.62,0,0,1-.42-2.52c0-.71,0-1.48,0-2.31s0-1.64,0-2.41a13.86,13.86,0,0,1,.41-3,14.57,14.57,0,0,1,1.06-2.9,12.14,12.14,0,0,1,1.66-2.51,8.69,8.69,0,0,1,2.22-1.85,4.81,4.81,0,0,1,2.11-.7,2.86,2.86,0,0,1,1.69.41,3.13,3.13,0,0,1,1.14,1.41,6.09,6.09,0,0,1,.43,2.3,1.2,1.2,0,0,1-.11.48.8.8,0,0,1-.27.32l-2.25,1.3c-.2.12-.33.13-.4.06a1.25,1.25,0,0,1-.19-.49,3.91,3.91,0,0,0-.2-.57,1,1,0,0,0-.37-.46,1,1,0,0,0-.62-.16,2.13,2.13,0,0,0-1,.34,3.6,3.6,0,0,0-1,.82,4.76,4.76,0,0,0-.66,1,5.39,5.39,0,0,0-.37,1.2A9,9,0,0,0,37,108.63Z"
            />
            <path
              className={classes.cls_45}
              d="M51.6,92.86a4.64,4.64,0,0,1,2-.68,3,3,0,0,1,1.59.34,2.69,2.69,0,0,1,1.05,1.09,3.39,3.39,0,0,1,.39,1.55,1,1,0,0,1-.11.47.66.66,0,0,1-.25.32l-2.25,1.3a.71.71,0,0,1-.39.12.61.61,0,0,1-.3-.15l-.16-.17a1,1,0,0,0-.32-.2,1.07,1.07,0,0,0-.52,0,2.09,2.09,0,0,0-.76.29,4.93,4.93,0,0,0-.62.43,3.8,3.8,0,0,0-.54.52,2.46,2.46,0,0,0-.38.63,2,2,0,0,0-.14.74.79.79,0,0,0,.16.57.71.71,0,0,0,.55.17,4.78,4.78,0,0,0,1-.15l1.58-.41a5.17,5.17,0,0,1,1.65-.21,2,2,0,0,1,1.18.44,2.41,2.41,0,0,1,.71,1.18,7.51,7.51,0,0,1,.23,2,8.76,8.76,0,0,1-.4,2.64,10.2,10.2,0,0,1-1.11,2.45,11.18,11.18,0,0,1-1.68,2.13,10.34,10.34,0,0,1-2.13,1.62,5.05,5.05,0,0,1-2.13.76,2.93,2.93,0,0,1-1.66-.3,2.67,2.67,0,0,1-1.1-1.13,3.86,3.86,0,0,1-.41-1.75,1.12,1.12,0,0,1,.11-.47.73.73,0,0,1,.25-.32l2.26-1.3a.71.71,0,0,1,.38-.13.54.54,0,0,1,.27.12,2.88,2.88,0,0,1,.21.23,1.22,1.22,0,0,0,.37.27,1,1,0,0,0,.58.1,2.08,2.08,0,0,0,.87-.31,6.23,6.23,0,0,0,1.52-1.19,2.07,2.07,0,0,0,.61-1.45.57.57,0,0,0-.22-.53,1.16,1.16,0,0,0-.67-.11,6.72,6.72,0,0,0-1.14.23l-1.65.42a2.49,2.49,0,0,1-2.59-.46,4.73,4.73,0,0,1-.82-3.17A9,9,0,0,1,47.07,99a10.9,10.9,0,0,1,1-2.39,11.24,11.24,0,0,1,1.54-2.15A8.66,8.66,0,0,1,51.6,92.86Z"
            />
            <path
              className={classes.cls_45}
              d="M64.06,85.67a4.51,4.51,0,0,1,2-.68,2.94,2.94,0,0,1,1.6.34,2.76,2.76,0,0,1,1,1.09A3.39,3.39,0,0,1,69.12,88a1.19,1.19,0,0,1-.11.47.72.72,0,0,1-.25.32l-2.25,1.3a.5.5,0,0,1-.69,0l-.17-.17a.79.79,0,0,0-.31-.2,1.2,1.2,0,0,0-.52,0,2.08,2.08,0,0,0-.76.3,4.22,4.22,0,0,0-.62.42,4.48,4.48,0,0,0-.54.52,2.85,2.85,0,0,0-.38.63,2.12,2.12,0,0,0-.14.75.79.79,0,0,0,.16.57.75.75,0,0,0,.55.17,4.62,4.62,0,0,0,1-.15l1.59-.41a5.52,5.52,0,0,1,1.65-.22,2,2,0,0,1,1.18.45,2.4,2.4,0,0,1,.7,1.18,7.09,7.09,0,0,1,.24,2,9.08,9.08,0,0,1-.4,2.64A10.38,10.38,0,0,1,68,100.94a11.23,11.23,0,0,1-1.69,2.13,10,10,0,0,1-2.12,1.62,5.34,5.34,0,0,1-2.13.76,2.93,2.93,0,0,1-1.66-.3,2.73,2.73,0,0,1-1.1-1.13,3.89,3.89,0,0,1-.41-1.75,1.2,1.2,0,0,1,.11-.48.75.75,0,0,1,.25-.31l2.25-1.3a.67.67,0,0,1,.38-.13.57.57,0,0,1,.28.12l.21.22a1.09,1.09,0,0,0,.37.28,1.12,1.12,0,0,0,.58.1,2.08,2.08,0,0,0,.87-.32,6.4,6.4,0,0,0,1.52-1.18,2.07,2.07,0,0,0,.61-1.45.58.58,0,0,0-.22-.54,1.17,1.17,0,0,0-.67-.1,6.81,6.81,0,0,0-1.15.22c-.46.13-1,.27-1.64.42A2.47,2.47,0,0,1,60,97.37a4.73,4.73,0,0,1-.82-3.17,9.16,9.16,0,0,1,.34-2.37,11,11,0,0,1,1-2.38A10.54,10.54,0,0,1,62,87.3,8.46,8.46,0,0,1,64.06,85.67Z"
            />
          </g>
          <g id="Text_Box-3" data-name="Text Box">
            <g id="_4" data-name="{}">
              <g id="Speech_Bubble-4" data-name="Speech Bubble">
                <g id="Speach_Bubble-3" data-name="Speach Bubble">
                  <path
                    className={classes.cls_10}
                    d="M70.86,127.36,17,158.4a3,3,0,0,0-1.33,2.32V190.8A2.92,2.92,0,0,0,17,193.1l5.32,3a3,3,0,0,0,2.68,0l53.89-31a3,3,0,0,0,1.34-2.32V132.67a2.9,2.9,0,0,0-1.35-2.3l-5.32-3A3,3,0,0,0,70.86,127.36Z"
                  />
                  <path
                    className={classes.cls_4}
                    d="M80.19,132.43c-.11-.67-.66-.92-1.32-.53L25,162.94a2.75,2.75,0,0,0-.94,1l-8-4.59a2.73,2.73,0,0,1,.93-.95l53.88-31.05a3,3,0,0,1,2.69,0l5.31,3A2.94,2.94,0,0,1,80.19,132.43Z"
                  />
                  <path
                    className={classes.cls_3}
                    d="M78.87,131.9,25,162.94a3,3,0,0,0-1.34,2.32v30.08c0,.85.6,1.2,1.34.77l53.89-31a3,3,0,0,0,1.34-2.32V132.67C80.21,131.82,79.61,131.47,78.87,131.9Z"
                  />
                </g>
              </g>
            </g>
            <path
              className={classes.cls_45}
              d="M57.68,151.12a4.53,4.53,0,0,1,2-.67,2.83,2.83,0,0,1,1.59.34,2.57,2.57,0,0,1,1.05,1.09,3.52,3.52,0,0,1,.4,1.54,1.07,1.07,0,0,1-.12.48.58.58,0,0,1-.25.31l-2.25,1.31a.61.61,0,0,1-.39.11.67.67,0,0,1-.3-.14l-.16-.17a.84.84,0,0,0-.32-.2,1.2,1.2,0,0,0-.52-.05,2,2,0,0,0-.75.29,5.39,5.39,0,0,0-.63.43,4.45,4.45,0,0,0-.54.52,2.48,2.48,0,0,0-.37.63,1.86,1.86,0,0,0-.15.75.83.83,0,0,0,.16.57.77.77,0,0,0,.55.17,4.32,4.32,0,0,0,1-.16l1.58-.41a5.17,5.17,0,0,1,1.65-.21,1.94,1.94,0,0,1,1.18.45,2.41,2.41,0,0,1,.71,1.18,7.43,7.43,0,0,1,.23,2,8.66,8.66,0,0,1-.4,2.64,10.94,10.94,0,0,1-4.92,6.21,5.16,5.16,0,0,1-2.13.75,2.79,2.79,0,0,1-1.66-.3,2.54,2.54,0,0,1-1.09-1.13,3.73,3.73,0,0,1-.42-1.74,1.2,1.2,0,0,1,.11-.48.79.79,0,0,1,.25-.32l2.26-1.3a.68.68,0,0,1,.38-.12.54.54,0,0,1,.27.12,2.39,2.39,0,0,1,.21.22,1.09,1.09,0,0,0,.37.28,1.14,1.14,0,0,0,.58.1,2,2,0,0,0,.87-.32,6.46,6.46,0,0,0,1.53-1.18,2.12,2.12,0,0,0,.61-1.46.57.57,0,0,0-.23-.53,1.17,1.17,0,0,0-.67-.1,6.55,6.55,0,0,0-1.14.22q-.7.19-1.65.42a2.49,2.49,0,0,1-2.59-.45,4.76,4.76,0,0,1-.81-3.17,9.14,9.14,0,0,1,.33-2.37,11.64,11.64,0,0,1,1-2.39,11.17,11.17,0,0,1,1.54-2.14A8.81,8.81,0,0,1,57.68,151.12Z"
            />
            <path
              className={classes.cls_45}
              d="M46.33,168c0-.19,0-.62,0-1V164.5c0-.41,0-.73,0-.95a7.48,7.48,0,0,0-.16-1.08c-.21-1-.55-1-.8-1.84a2.8,2.8,0,0,1,0-2,2.08,2.08,0,0,1,1-1s-1.07.91-1,1,1.64-1.3,2-1-.19,2-1,2a1,1,0,0,1-1-1,1.08,1.08,0,0,1,1-1h1l-2,1h0a3,3,0,0,0,1-1s-.95,1-1,1a1.69,1.69,0,0,1,1-1,1.55,1.55,0,0,1,1,0,8,8,0,0,1-2,1c-.07-.11,1-1,1-1a2.81,2.81,0,0,1,1.66-.26c.55.19.78.84,1.06,1.68a8.69,8.69,0,0,1,.42,2.53c0,.71,0,1.48,0,2.31s0,1.63,0,2.4a13.78,13.78,0,0,1-.41,3A13.57,13.57,0,0,1,48,172.2a11.88,11.88,0,0,1-1.66,2.51,8.49,8.49,0,0,1-2.22,1.85,4.69,4.69,0,0,1-2.11.7,2.88,2.88,0,0,1-1.69-.41,3.13,3.13,0,0,1-1.14-1.41,6,6,0,0,1-.43-2.3,1.06,1.06,0,0,1,.12-.47.7.7,0,0,1,.26-.33l2.26-1.3q.28-.16.39-.06a1.25,1.25,0,0,1,.19.49,3.63,3.63,0,0,0,.2.58,1.05,1.05,0,0,0,.37.46,1.08,1.08,0,0,0,.62.16,2.17,2.17,0,0,0,1-.35,3.41,3.41,0,0,0,1-.82A5.79,5.79,0,0,0,46.33,168Zm1-9.37,2,2"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
